<div class="mobile-header">
    <div class="container">
        <div class="row">
            <div class="col-md-12 mainHeader">
                <div class="logo">
                    <a routerLink="/home">
                        <img src="../../../assets/images/header/mobileLogo.png" alt="">
                    </a>
                </div>
                <div class="rightbar">
                    <ul>
                        <li *ngIf="isLoggedIn">
                            <!-- <button (click)="NotificationPopup()"> -->
                            <button (click)="onDownloadClick('bottom')">
                                <img src="../../../assets/images/header/mobile-header-icon1.svg" alt="">
                            </button>
                        </li>
                        <li *ngIf="isLoggedIn">
                            <button routerLink="/my-wallet">
                                <img src="../../../assets/images/header/mobile-header-icon2.svg" alt="">
                            </button>
                        </li>
                        <li *ngIf="isLoggedIn">
                            <button (click)="mobileMenu()" class="mobileUserProfileIcon">
                                <img [src]="(loggedInProfilePic?.length !== 0) ? loggedInProfilePic : 'assets/images/academy_dummy.jpg'"
                                    alt="" class="mainProfileImage">

                                <img src="../../../assets/images/header/headerIcon.svg" alt="" class="headerIcon">
                                <!-- <img src="../../../assets/images/header/mobile-header-icon3.svg" alt=""> -->
                            </button>
                        </li>
                        <li *ngIf="!isLoggedIn">
                            <button class="primery-button mobileHeaderLoginBtn" (click)="signInSignUp(); "
                                *ngIf="!isLoggedIn">
                                <div class="icon">
                                    <img src="../../../assets/images/home-page/user.svg" alt="">
                                </div>
                                <div class="title">
                                    login / register
                                </div>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- ======= Top Header bar ======= -->
<div class="top-header w-full col-12 ">
    <div class="container flex justify-between">
        <div class="left-div">
            <div class="top-buttons">
                <ul class="d-flex items-center">
                    <li class="active">
                        <div class="flex items-center ">
                            <div class="icon">
                                <img src="../../../assets/images/icon.png" alt="">
                            </div>
                            <div class="title">
                                <span>Tennis</span>
                            </div>
                        </div>
                    </li>
                    <li class="cursor-pointer" (click)="onDownloadClick('bottom')">
                        <div class="flex items-center">
                            <div class="icon">
                                <img src="../../../assets/images/icon2.png" alt="">
                            </div>
                            <div class="title">
                                <span>Pickleball</span>
                            </div>
                        </div>
                    </li>
                    <li class="cursor-pointer" (click)="onDownloadClick('bottom')">
                        <div class="flex items-center">
                            <div class="icon">
                                <img src="../../../assets/images/icon3.png" alt="">
                            </div>
                            <div class="title">
                                <span>Padel</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="right-div d-none">
            <div class="slider-main">
                <div class="leftIndicator">
                    <img src="../../../assets/images/header/leftIndicate.svg" alt="">
                </div>
                <swiper fxFlex="auto" [config]="liveMatches">
                    <div *ngFor="let liveScore of liveMatchesList">
                        <div class="livescoreDiv">
                            <div class="headingTitle">
                                <h4><span class="round">{{liveScore.matchRound}} · </span>{{liveScore.matchRoundName}}
                                </h4>
                            </div>
                            <div class="body">
                                <ul class="matchList">
                                    <li [ngClass]="liveScore.player1matchStatus === 'winner' ? 'winner-div' : ''">
                                        <div class="matcheScore">
                                            <div class="leftdiv">
                                                <div class="flagS">
                                                    <img [src]="liveScore.player1Flag" alt="">
                                                </div>
                                                <div class="player">
                                                    {{liveScore.player1Order}}
                                                </div>
                                                <div class="playerName">
                                                    {{liveScore.player1Name}}
                                                </div>
                                            </div>
                                            <div class="rightdiv">
                                                <div class="points">
                                                    <ul>
                                                        <li>
                                                            4
                                                        </li>
                                                        <li>
                                                            6
                                                        </li>
                                                        <li>
                                                            6
                                                        </li>
                                                        <li>
                                                            6
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li [ngClass]="liveScore.player2matchStatus === 'winner' ? 'winner-div' : ''">
                                        <div class="matcheScore">
                                            <div class="leftdiv">
                                                <div class="flagS">
                                                    <img src="../../../assets/images/header/flg2.png" alt="">
                                                </div>
                                                <div class="player">
                                                    2
                                                </div>
                                                <div class="playerName">
                                                    C. Alcaraz
                                                </div>
                                            </div>
                                            <div class="rightdiv">
                                                <div class="points">
                                                    <ul>
                                                        <li>
                                                            6
                                                        </li>
                                                        <li>
                                                            4
                                                        </li>
                                                        <li>
                                                            4
                                                        </li>
                                                        <li>
                                                            4
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </swiper>
                <div class="rightIndicator">
                    <img src="../../../assets/images/header/rightIndicate.svg" alt="">
                </div>


            </div>

            <!-- <div class="livescoreDiv">
                <div class="headingTitle">
                    <h4>Final · Centre Court</h4>
                </div>
                <div class="body">
                    <ul class="matchList">
                        <li>
                            <div class="matcheScore">
                                <div class="leftdiv">
                                    <div class="flagS">
                                        <img src="../../../assets/images/header/flg1.png" alt="">
                                    </div>
                                    <div class="player">
                                        1
                                    </div>
                                    <div class="playerName">
                                        J. Sinner
                                    </div>
                                </div>
                                <div class="rightdiv">
                                    <div class="points">
                                        <ul>
                                            <li>
                                                4
                                            </li>
                                            <li>
                                                6
                                            </li>
                                            <li>
                                                6
                                            </li>
                                            <li>
                                                6
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="matcheScore">
                                <div class="leftdiv">
                                    <div class="flagS">
                                        <img src="../../../assets/images/header/flg2.png" alt="">
                                    </div>
                                    <div class="player">
                                        2
                                    </div>
                                    <div class="playerName">
                                       C. Alcaraz
                                    </div>
                                </div>
                                <div class="rightdiv">
                                    <div class="points">
                                        <ul>
                                            <li>
                                                6
                                            </li>
                                            <li>
                                                4
                                            </li>
                                            <li>
                                                4
                                            </li>
                                            <li>
                                                4
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div> -->
            <!-- <div class="live-update">
                <div class="right-div-section">
                    <div class="matche-details">
                        <ul>
                            <li class="tournamentName">
                                <span>2025 Australian Open</span>
                            </li>
                            <li class="matches">
                                <div class="teamdetails flex">
                                    <div class="player-name">
                                        <div class="flag-icon">
                                            <img src="../../../assets/images/flag.png" alt="">
                                        </div>
                                        <div class="playerName">
                                            <h6>J. Sin</h6>
                                        </div>
                                        <div class="score">
                                            [40]
                                        </div>
                                    </div>
                                    <div class="vs">
                                        VS
                                    </div>
                                    <div class="player-name">
                                        <div class="flag-icon">
                                            <img src="../../../assets/images/flag.png" alt="">
                                        </div>
                                        <div class="playerName">
                                            <h6>J. Sin</h6>
                                        </div>
                                        <div class="score">
                                            [40]
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="livescore flex">
                                    <div class="total-point">
                                        <div class="palyer-one-score">
                                            2
                                        </div>
                                        <div class="palyer-two-score">
                                            2
                                        </div>
                                    </div>
                                    <div class="scoreBreak">
                                        <ul>
                                            <li>
                                                6 <span>-</span> 2
                                            </li>
                                            <li>
                                                6 <span>-</span> 2
                                            </li>
                                            <li>
                                                6 <span>-</span> 2
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div> -->
        </div>
    </div>

</div>

<!-- ======= Top Header bar ======= -->
<!-- <nav class="top-bar bg-dark">
    <div class="container">
        <div class="row">
            <div class="col-md-12 main">
                <div class="info col-md-3">
                    <div class="media">
                        <div class="social-links ">
                            <a href="https://www.youtube.com/channel/UCwzZgIn3_q15e9mcoSvyJbg" class="youtube"
                                target="_blank"><i class="bx bxl-youtube"></i></a>
                            <a href="https://www.facebook.com/tennispremierleague/" class="facebook" target="_blank"><i
                                    class="bx bxl-facebook"></i></a>
                            <a href="https://www.instagram.com/tennispremierleague/" class="instagram"
                                target="_blank"><i class="bx bxl-instagram"></i></a>
                       
                            <a href="https://www.linkedin.com/company/tennis-premier-league/?originalSubdomain=in"
                                class="linkedin" target="_blank"><i class="bx bxl-linkedin"></i></a>
                        </div>
                    </div>
                </div>
                <div class="marquee">
                    <marquee width="100%" direction="left" height="auto">
                        
                    </marquee>
                </div>
                <div class="float-right col-md-9 top-right-bar pl-0">
                    <div class="right-bar-section">


                        <div class="right-bar-list">
                            <ul class="p-0">
                                <li class="dropdown notifications" *ngIf="isLoggedIn && !isAcademy" #notificationDiv>
                                    <div class="icons" (click)="notification.show($event, notificationDiv)">
                                        <i class="pi pi-bell text-3xl" pBadge *ngIf="totalCount > 0"
                                            value="{{ totalCount }}"></i>
                                        <i class="pi pi-bell text-3xl" (click)="notification.show($event, notificationDiv)" *ngIf="totalCount === 0"></i>
                                       
                                    </div>
                                    <p-overlayPanel #notification ngClass="testClass">
                                        <ng-template pTemplate="content">
                                            <div class="notification-div">
                                                <div class="notification-header">
                                                    <h4>Notification ({{totalCount < 0 ? 0:totalCount}} new)</h4>
                                                </div>
                                                <div class="notification-body">
                                                    <div class="notification-list">
                                                        <div class="card flex justify-content-center p-p-0">
                                                            <p-virtualScroller rows="10" [value]="finalnotificationList"
                                                                scrollHeight="450px" [itemSize]="100" [lazy]="false"
                                                                (onLazyLoad)="onLazyLoadNotification()">
                                                                <ng-template pTemplate="item" let-item
                                                                    let-options="options">
                                                                    <div (click)="popNotification(item.id)" class="notification-list-div"
                                                                        [ngClass]="{ 'active': i === selectedItemIndex }">
                                                                        
                                                                        <div class="ntf-body"> 
                                                                          
                                                                            <a *ngIf="item.type=='Tournament'"
                                                                                routerLink="/tournaments"
                                                                                class="notificationAnchor"
                                                                                (click)="markNotificationRead(item.id,false)">
                                                                                <h6 [innerHtml]="item.message"></h6>
                                                                                <span class="date">{{item.created_at |date:'dd/MM/yyyy HH:mm a'}}</span>
                                                                                <span *ngIf="!item.read" class="notseen"></span>
                                                                            </a>
                                                                            <a *ngIf="item.type=='MyTournament'"
                                                                                routerLink="/profile-tournament"
                                                                                class="notificationAnchor"
                                                                                (click)="markNotificationRead(item.id,false)">
                                                                                <h6 [innerHtml]="item.message"></h6>
                                                                                <span class="date">{{item.created_at |date:'dd/MM/yyyy HH:mm a'}}</span>
                                                                                <span *ngIf="!item.read" class="notseen"></span>
                                                                            </a>
                                                                            <a *ngIf="item.type=='MyAchivements'"
                                                                                routerLink="/my-achivements"
                                                                                class="notificationAnchor"
                                                                                (click)="markNotificationRead(item.id,false)">
                                                                                <h6 [innerHtml]="item.message"></h6>
                                                                                <span class="date">{{item.created_at |date:'dd/MM/yyyy HH:mm a'}}</span>
                                                                                <span *ngIf="!item.read" class="notseen"></span>
                                                                            </a>
                                                                            <a *ngIf="item.type=='FAP'"
                                                                                routerLink="/profile-request"
                                                                                class="notificationAnchor"
                                                                                (click)="markNotificationRead(item.id,false)">
                                                                                <h6 [innerHtml]="item.message"></h6>
                                                                                <span class="date">{{item.created_at |date:'dd/MM/yyyy HH:mm a'}}</span>
                                                                                <span *ngIf="!item.read" class="notseen"></span>
                                                                            </a>
                                                                            <a *ngIf="item.type=='Contest'"
                                                                                routerLink="/contest"
                                                                                class="notificationAnchor"
                                                                                (click)="markNotificationRead(item.id,false)">
                                                                                <h6 [innerHtml]="item.message"></h6>
                                                                                <span class="date">{{item.created_at |date:'dd/MM/yyyy HH:mm a'}}</span>
                                                                                <span *ngIf="!item.read" class="notseen"></span>
                                                                            </a>
                                                                            <a *ngIf="item.type=='MyContest'" routerLink="/my-contest" class="notificationAnchor"
                                                                            (click)="markNotificationRead(item.id,false)">
                                                                            <h6 [innerHtml]="item.message"></h6>
                                                                            <span class="date">{{item.created_at |date:'dd/MM/yyyy HH:mm a'}}</span>
                                                                            <span *ngIf="!item.read" class="notseen"></span>
                                                                            </a>
                                                                            <a *ngIf="item.type=='Kyc'"
                                                                                routerLink="/profile-info"
                                                                                class="notificationAnchor"
                                                                                (click)="markNotificationRead(item.id,false)">
                                                                                <h6 [innerHtml]="item.message"></h6>
                                                                                <span class="date">{{item.created_at |date:'dd/MM/yyyy HH:mm a'}}</span>
                                                                                <span *ngIf="!item.read" class="notseen"></span>
                                                                            </a>
                                                                            <a *ngIf="item.type=='Wallet'"
                                                                                routerLink="/my-wallet"
                                                                                class="notificationAnchor"
                                                                                (click)="markNotificationRead(item.id,false)">
                                                                                <h6 [innerHtml]="item.message"></h6>
                                                                                <span class="date">{{item.created_at |date:'dd/MM/yyyy HH:mm a'}}</span>
                                                                                <span *ngIf="!item.read" class="notseen"></span>
                                                                            </a>
                                                                          
                                                                           
                                                                        </div>
                                                                    </div>
                                                                </ng-template>
                                                                <ng-template pTemplate="loadingItem" let-item>
                                                                    <p-skeleton height="90px"
                                                                        [style]="{ 'margin-top': '10px' }"></p-skeleton>
                                                                </ng-template>
                                                            </p-virtualScroller>
                                                        </div>

                                                       
                                                    </div>
                                                    <div class="notification-view-all">
                                                        <button (click)="loadMoreNotification()">See More
                                                            Notification</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </p-overlayPanel>
                                </li>

                                <li class="mobile-d-none" *ngIf="!isLoggedIn">
                                    <a class="nav-link scrollto" routerLink="refer-earn">
                                        <button class="btn find-patner-btn"> Refer & Earn</button>
                                    </a>
                                </li>
                                <li class="mobile-d-none" *ngIf="!isLoggedIn">
                                    <a routerLink="/" class="nav-link scrollto">
                                        <button class="btn find-patner-btn"> LOGIN/REGISTER</button>
                                    </a>
                                </li>
                             
                                <li *ngIf="isLoggedIn" class="wallte-indicatoir dropdown user-account-page">
                                    <div *ngIf="loggedInUser.userdata.rolename != 'academy'" class="media">
                                        <div class="media-left">
                                            <div class="icon">
                                                <i class='bx bx-wallet-alt'></i>
                                            </div>
                                        </div>
                                        <div *ngIf="loggedInUser.userdata.rolename != 'academy'" class="media-body">
                                            <h6>Balance</h6>
                                            <h2><span class="rupee-icon"><i
                                                        class='bx bx-rupee'></i></span>{{totalAvailableCash | numberFormatter}}/{{totalAvailableCoins | numberFormatter}}
                                            </h2>
                                        </div>
                                        <div class="media-right">
                                            <i class='bx bx-chevron-down'></i>
                                        </div>
                                    </div>
                                    <div *ngIf="loggedInUser.userdata.rolename != 'academy'" class="hover-div">
                                        <ul>
                                            <div class="total-balance">
                                                <div class="Cash lists">
                                                    <h6>TPL Cash</h6>
                                                    <h2><span class="rupee-icon"><i
                                                                class='bx bx-rupee'></i></span>{{totalAvailableCash | numberFormatter}}
                                                    </h2>
                                                </div>
                                                <div class="Cash lists">
                                                    <h6>Contest Cash</h6>
                                                    <h2><span class="rupee-icon"><i
                                                                class='bx bx-rupee'></i></span>{{totalAvailableContestCash | numberFormatter}}
                                                    </h2>
                                                </div>
                                                <div class="coins lists">
                                                    <h6>TPL Coins</h6>
                                                    <h2>{{totalAvailableCoins | numberFormatter}}</h2>
                                                </div>
                                            </div>
                                            <li> <a (click)="openWallet()">
                                                    <span><i class='bx bx-transfer-alt'></i> Wallet Activity</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li class=" dropdown user-account-page" *ngIf="isLoggedIn">
                                    <div class=" media user-div">
                                        <div class="media-left">
                                            <div class="user-image">
                                                <img [src]="(loggedInProfilePic.length !== 0) ? loggedInProfilePic : '../../../../assets/images/academy_dummy.jpg'" alt="">
                                            </div>
                                        </div>
                                        <div class="media-body">
                                            <h1>{{loggedInUsername}}</h1>
                                        </div>
                                    </div>
                                    <div class="hover-div ">
                                        <ul>
                                            <li data-bs-dismiss="modal" *ngIf="!isAcademy" routerLink="profile-info">
                                                <a routerLink="profile-info">
                                                    <span><i class='bx bx-user'></i> My Profile</span>
                                                </a>
                                            </li>
                                           
                                           
                                                <li data-bs-dismiss="modal" *ngIf="!isAcademy && currentDate<= passEndDate"
                                                    routerLink="player-ticket">
                                                    <a routerLink="player-ticket">
                                                        <span><i class='bx bx-barcode'></i> My Tickets</span>
                                                    </a>
                                                </li>
                                         
                                            <li data-bs-dismiss="modal" *ngIf="!isAcademy" routerLink="my-wallet">
                                                <a routerLink="my-wallet">
                                                    <span><i class='bx bx-wallet-alt'></i> My Wallet</span>
                                                </a>
                                            </li>
                                           
                                            <li data-bs-dismiss="modal" *ngIf="isAcademy"
                                                routerLink="academies-profile">
                                                <a routerLink="academies-profile">
                                                    <span><i class='bx bxs-graduation'></i> Academy</span>
                                                </a>
                                            </li>
                                            <li *ngIf="isAcademy" data-bs-dismiss="modal" routerLink="payment-history">
                                                <a routerLink="payment-history">
                                                    <span><i class='bx bx-time'></i> Payment history</span>
                                                </a>
                                            </li>


                                            <li data-bs-dismiss="modal" routerLink="refer-earn">
                                                <a routerLink="refer-earn">
                                                    <span><i class='bx bx-user-plus' style="font-size: 22px;"></i> Refer
                                                        & Earn</span>
                                                </a>
                                            </li>

                                            <li *ngIf="isAcademy" data-bs-dismiss="modal" routerLink="/reviews">
                                                <a routerLink="/reviews" class="review-link">
                                                    <span><i class='pi pi-comment'></i> Academy Reviews </span>
                                                    <p-badge [value]="academyReviewCount"></p-badge>

                                                </a>
                                            </li>

                                            <li *ngIf="!isAcademy && this.item?.age >=18" data-bs-dismiss="modal"
                                                routerLink="bank-details">
                                                <a routerLink="bank-details">
                                                    <span>
                                                        <span class="bankicon">
                                                            <img src="../../../assets/img/KYC/bank.svg" alt="">
                                                        </span>
                                                        Bank Settings
                                                    </span>
                                                </a>
                                            </li>




                                            <li data-bs-dismiss="modal" (click)="signOut()">
                                                <a (click)="signOut()">
                                                    <span><i class='bx bx-log-out-circle'></i> Logout</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</nav> -->


<!-- ======= End Top Header bar ======= -->

<header id="header">
    <div class="container">
        <div class="row">
            <div class="col-md-12 d-flex align-items-center justify-content-lg-between headerTop">
                <div class="logo">
                    <a routerLink="/home">
                        <img src="../../../assets/images/header/mobileLogo.png" alt="" class="desktop-logo">
                        <!-- <img src="../../../assets/img/logo/new-logos/header-logo.png" alt="" class="mobile-logo"> -->
                    </a>
                </div>

                <div class="header-right-part  d-flex">
                    <div class="header-button">

                        <!-- <button class="primery-button" (click)="signInSignUp(); "  *ngIf="isLoggedIn"> -->




                        <button class="download-button mr-3" (click)="downloadApp(); ">
                            <div class="title">
                                Download<br>the app
                            </div>
                            <div class="line"></div>
                            <ul class="icons-div">
                                <li>
                                    <a href="#">
                                        <img src="../../../assets/images/header/playstore.png" alt="">
                                    </a>
                                </li>
                                <li>
                                    <a href="#">
                                        <img src="../../../assets/images/header/apple.svg   " alt="">
                                    </a>
                                </li>
                            </ul>
                        </button>
                        <button class="bg-white-button mr-3" (click)="downloadAfilliateAcademy(); ">
                            <div class="icon">
                                <img src="../../../assets/images/header/affiliate.svg " alt="">
                            </div>
                            <div class="title">
                                Affiliate your Academy
                            </div>
                        </button>
                        <div class="userProfile cursor-pointer" (click)="profile.toggle($event)" *ngIf="isLoggedIn">
                            <div class=" media user-profile">
                                <div class="media-left">
                                    <div class="user-image">
                                        <img [src]="(loggedInProfilePic.length !== 0) ? loggedInProfilePic : '../../../../assets/images/academy_dummy.jpg'"
                                            alt="" class="profile">
                                        <div class="icon">
                                            <img src="../../../assets/images/header/profileMenues.svg" alt="">
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="media-body">
                                    <h1>{{loggedInUsername}}</h1>
                                </div> -->
                            </div>
                            <p-overlayPanel #profile styleClass="profile-popup">
                                <ng-template pTemplate="content">
                                    <div class="profile-menues">
                                        <div class="profile-header">
                                            <div class="left-user-details">
                                                <div class="profileImage">
                                                    <img [src]="(loggedInProfilePic.length !== 0) ? loggedInProfilePic : '../../../../assets/images/academy_dummy.jpg'"
                                                        alt="">
                                                </div>
                                                <div class="username">
                                                    <h4>{{loggedInUsername}}</h4>
                                                </div>
                                                <div class="subscribe cursor-pointer">
                                                    <h6 routerLink="profile-info">VIEW PROFILE</h6>
                                                </div>
                                            </div>
                                            <div class="right-user-details">
                                                <h6>TPL RANK</h6>
                                                <h2>#{{playerRank}}</h2>
                                            </div>
                                        </div>
                                        <div class="profile-body">
                                            <!-- <div class="swichAccount">
                                            <div class="accountSwith">
                                                <div class="icon">
                                                    <img src="../../../assets/images/header/user-switch.svg" alt="">
                                                </div>
                                                <div class="title">
                                                    switch account
                                                </div>
                                            </div>
                                            <div class="users">
                                                <div class="user-main0div">
                                                    <p-avatarGroup styleClass="p-mb-0">
                                                        <p-avatar image="assets/demo/images/avatar/amyelsner.png"
                                                            size="large" shape="circle"></p-avatar>
                                                        <p-avatar image="assets/demo/images/avatar/asiyajavayant.png"
                                                            size="large" shape="circle"></p-avatar>
                                             
                                                        <p-avatar label="+2" shape="circle" size="large" [style]="{'font-family':'Gilroy-SemiBold','font-size':'20px','background-color':'#E3F2E5', 'color': '#1C9A2D', 'border-color': '#1C9A2D'}"></p-avatar>
                                                    </p-avatarGroup>
                                                </div>
                                                <div class="icon">
                                                    <img src="../../../assets/images/header/m-right.svg" alt="">
                                                </div>

                                            </div>
                                        </div> -->
                                            <div class="panel-details">
                                                <ul>
                                                    <li>
                                                        <div class="icons-div">
                                                            <div class="icon">
                                                                <img src="../../../assets/images/header/location.svg"
                                                                    alt="">
                                                            </div>
                                                            <div class="title">
                                                                <h4>Mumbai</h4>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <a routerLink="my-wallet">
                                                            <div class="icons-div">
                                                                <div class="icon">
                                                                    <img src="../../../assets/images/header/wallet.svg"
                                                                        alt="">
                                                                </div>
                                                                <div class="title">
                                                                    <h4>₹{{ totalAvailableCash | number:'1.0-0' }}</h4>
                                                                </div>
                                                            </div>
                                                        </a>

                                                    </li>
                                                    <li>

                                                        <div class="icons-div" (click)="onDownloadClick('bottom')">
                                                            <div class="icon">
                                                                <img src="../../../assets/images/header/notification.svg"
                                                                    alt="">
                                                            </div>
                                                            <div class="title">
                                                                <h4>{{ totalCount }}</h4>
                                                            </div>
                                                        </div>

                                                    </li>
                                                </ul>
                                            </div>

                                            <div class="notificationList">
                                                <ul>
                                                    <li>
                                                        <a routerLink="refer-earn">
                                                            <div class="menuesList">
                                                                <div class="icon">
                                                                    <img src="../../../assets/images/header/user-star.svg"
                                                                        alt="">
                                                                </div>
                                                                <div class="title">
                                                                    <span>
                                                                        Refer and Earn
                                                                    </span>
                                                                    <h6>Win 100 TPL coin for each referral</h6>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <!-- routerLink="bank-details" -->
                                                        <a (click)="onDownloadClick('bottom')">
                                                            <div class="menuesList">
                                                                <div class="icon">
                                                                    <img src="../../../assets/images/header/bank.svg"
                                                                        alt="">
                                                                </div>
                                                                <div class="title">

                                                                    <h6>Bank Settings</h6>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a (click)="signOut()">
                                                            <div class="menuesList">
                                                                <div class="icon">
                                                                    <img src="../../../assets/images/header/logout.svg"
                                                                        alt="">
                                                                </div>
                                                                <div class="title">

                                                                    <h6 style="color:red;">Logout</h6>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                    </div>
                                </ng-template>

                            </p-overlayPanel>
                        </div>
                        <button class="primery-button mr-3" (click)="signInSignUp(); " *ngIf="!isLoggedIn">
                            <div class="icon">
                                <img src="../../../assets/images/home-page/user.svg" alt="">
                            </div>
                            <div class="title">
                                login / register
                            </div>
                        </button>
                        <button (click)="menues.toggle($event)" class="menuesBTn">
                            <div class="icon">
                                <img src="../../../assets/images/home-page/menus.svg" alt="">
                            </div>
                            <div class="title">
                                MENU
                            </div>
                        </button>
                        <p-overlayPanel #menues styleClass="menues-popup topdesktopMenues">
                            <ng-template pTemplate="content">
                                <div class="profile-menues" id="profile-popup-desktop">
                                    <div class="profile-body">
                                        <div class="navMenue_main">
                                            <div class="notificationList">
                                                <ul>
                                                    <li>
                                                        <a routerLink="home">
                                                            <div class="menuesList">
                                                                <div class="icon">
                                                                    <img src="../../../assets/images/header/home.svg"
                                                                        alt="">
                                                                </div>
                                                                <div class="title">
                                                                    <h6>Home</h6>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <p-accordion>
                                                            <p-accordionTab>
                                                                <ng-template pTemplate="header">
                                                                    <span class="flex align-items-center gap-2 w-full">
                                                                        <div class="icon">
                                                                            <img src="../../../assets/images/header/aboutLeagueicon.png"
                                                                                alt="">
                                                                        </div>
                                                                        <span class="mainMenueTitle">
                                                                            Tennis Premier League
                                                                        </span>

                                                                    </span>
                                                                </ng-template>

                                                                <ul class="subMenueslist">
                                                                    <li>
                                                                        <a routerLink="about-the-league"
                                                                            (click)="mobileMenues = false">
                                                                            <span
                                                                                class="flex align-items-center gap-2 w-full">

                                                                                <span class="mainMenueTitle">
                                                                                    About TPL
                                                                                </span>

                                                                            </span>
                                                                        </a>

                                                                    </li>
                                                                    <li>
                                                                        <a class="cursor-pointer"
                                                                            (click)="onDownloadClick('bottom'); mobileMenues = false">
                                                                            <span
                                                                                class="flex align-items-center gap-2 w-full">

                                                                                <span class="mainMenueTitle">
                                                                                    Match Score
                                                                                </span>

                                                                            </span>
                                                                        </a>

                                                                    </li>
                                                                    <li>
                                                                        <a class="cursor-pointer"
                                                                            (click)="onDownloadClick('bottom'); mobileMenues = false">
                                                                            <span
                                                                                class="flex align-items-center gap-2 w-full">

                                                                                <span class="mainMenueTitle">
                                                                                    TPL Team Standings
                                                                                </span>

                                                                            </span>
                                                                        </a>

                                                                    </li>
                                                                    <li>
                                                                        <a routerLink="teams"
                                                                            (click)="mobileMenues = false">
                                                                            <span
                                                                                class="flex align-items-center gap-2 w-full">

                                                                                <span class="mainMenueTitle">
                                                                                    Teams
                                                                                </span>

                                                                            </span>
                                                                        </a>

                                                                    </li>
                                                                    <li>
                                                                        <a routerLink="sponsors"
                                                                            (click)="mobileMenues = false">
                                                                            <span
                                                                                class="flex align-items-center gap-2 w-full">

                                                                                <span class="mainMenueTitle">
                                                                                    Sponsors
                                                                                </span>

                                                                            </span>
                                                                        </a>

                                                                    </li>
                                                                    <li>
                                                                        <a routerLink="media"
                                                                            (click)="mobileMenues = false">
                                                                            <span
                                                                                class="flex align-items-center gap-2 w-full">

                                                                                <span class="mainMenueTitle">
                                                                                    Media
                                                                                </span>

                                                                            </span>
                                                                        </a>

                                                                    </li>
                                                                    <li>
                                                                        <a class="cursor-pointer"
                                                                            (click)="onDownloadClick('bottom'); mobileMenues = false">
                                                                            <span
                                                                                class="flex align-items-center gap-2 w-full">

                                                                                <span class="mainMenueTitle">
                                                                                    Highlights
                                                                                </span>

                                                                            </span>
                                                                        </a>

                                                                    </li>
                                                                    <li>
                                                                        <a class="cursor-pointer"
                                                                            (click)="onDownloadClick('bottom'); mobileMenues = false">
                                                                            <span
                                                                                class="flex align-items-center gap-2 w-full">

                                                                                <span class="mainMenueTitle">
                                                                                    Player Stats
                                                                                </span>

                                                                            </span>
                                                                        </a>

                                                                    </li>
                                                                </ul>

                                                            </p-accordionTab>
                                                        </p-accordion>
                                                    </li>
                                                    <!-- <li>
                                                        <p-accordion>
                                                            <p-accordionTab>
                                                                <ng-template pTemplate="header">
                                                                    <span class="flex align-items-center gap-2 w-full">
                                                                        <div class="icon">
                                                                            <img src="../../../assets/images/header/m-IconTorunament.svg"
                                                                                alt="">
                                                                        </div>
                                                                        <span class="mainMenueTitle">
                                                                            Tournaments
                                                                        </span>

                                                                    </span>
                                                                </ng-template>

                                                                <ul class="subMenueslist">
                                                                    <li>
                                                                        <a routerLink="/tournaments"
                                                                            (click)="mobileMenues = false">
                                                                            <span
                                                                                class="flex align-items-center gap-2 w-full">

                                                                                <span class="mainMenueTitle">
                                                                                    All Tournaments
                                                                                </span>

                                                                            </span>
                                                                        </a>

                                                                    </li>
                                                                    <li>
                                                                        <a
                                                                            (click)="onDownloadClick('bottom'); mobileMenues = false">
                                                                            <span
                                                                                class="flex align-items-center gap-2 w-full">

                                                                                <span class="mainMenueTitle">
                                                                                    My Tournaments
                                                                                </span>

                                                                            </span>
                                                                        </a>

                                                                    </li>

                                                                </ul>

                                                            </p-accordionTab>
                                                        </p-accordion>
                                                    </li>
                                                    <li>
                                                        <p-accordion>
                                                            <p-accordionTab>
                                                                <ng-template pTemplate="header">
                                                                    <span class="flex align-items-center gap-2 w-full">
                                                                        <div class="icon">
                                                                            <img src="../../../assets/images/header/m-IconBookcourt.svg"
                                                                                alt="">
                                                                        </div>
                                                                        <span class="mainMenueTitle">
                                                                            Book A Court
                                                                        </span>

                                                                    </span>
                                                                </ng-template>

                                                                <ul class="subMenueslist">
                                                                    <li>
                                                                        <a
                                                                            (click)="onDownloadClick('bottom'); mobileMenues = false">
                                                                            <span
                                                                                class="flex align-items-center gap-2 w-full">

                                                                                <span class="mainMenueTitle">
                                                                                    All Courts
                                                                                </span>

                                                                            </span>
                                                                        </a>

                                                                    </li>
                                                                    <li>
                                                                        <a
                                                                            (click)="onDownloadClick('bottom'); mobileMenues = false">
                                                                            <span
                                                                                class="flex align-items-center gap-2 w-full">

                                                                                <span class="mainMenueTitle">
                                                                                    My Bookings
                                                                                </span>

                                                                            </span>
                                                                        </a>

                                                                    </li>

                                                                </ul>

                                                            </p-accordionTab>
                                                        </p-accordion>
                                                    </li> -->
                                                    <!-- <li>
                                                        <p-accordion>
                                                            <p-accordionTab>
                                                                <ng-template pTemplate="header">
                                                                    <span class="flex align-items-center gap-2 w-full">
                                                                        <div class="icon">
                                                                            <img src="../../../assets/images/header/m-IconAcadmy.svg"
                                                                                alt="">
                                                                        </div>
                                                                        <span class="mainMenueTitle">
                                                                            Academies
                                                                        </span>

                                                                    </span>
                                                                </ng-template>

                                                                <ul class="subMenueslist">
                                                                    <li>
                                                                        <a routerLink="/academies"
                                                                            (click)="mobileMenues = false">
                                                                            <span
                                                                                class="flex align-items-center gap-2 w-full">

                                                                                <span class="mainMenueTitle">
                                                                                    All Academies
                                                                                </span>

                                                                            </span>
                                                                        </a>

                                                                    </li>
                                                                    <li>
                                                                        <a
                                                                            (click)="onDownloadClick('bottom'); mobileMenues = false">
                                                                            <span
                                                                                class="flex align-items-center gap-2 w-full">

                                                                                <span class="mainMenueTitle">
                                                                                    My Academies
                                                                                </span>

                                                                            </span>
                                                                        </a>
                                                                    </li>
                                                                </ul>

                                                            </p-accordionTab>
                                                        </p-accordion>
                                                    </li> -->
                                                    <!-- <li>
                                                        <p-accordion>
                                                            <p-accordionTab>
                                                                <ng-template pTemplate="header">
                                                                    <span class="flex align-items-center gap-2 w-full">
                                                                        <div class="icon">
                                                                            <img src="../../../assets/images/header/m-Iconfindp.svg"
                                                                                alt="">
                                                                        </div>
                                                                        <span class="mainMenueTitle">
                                                                            Find a partner
                                                                        </span>

                                                                    </span>
                                                                </ng-template>

                                                                <ul class="subMenueslist">
                                                                    <li>
                                                                        <a routerLink="find-partner"
                                                                            (click)="mobileMenues = false">
                                                                            <span
                                                                                class="flex align-items-center gap-2 w-full">

                                                                                <span class="mainMenueTitle">
                                                                                    Search
                                                                                </span>

                                                                            </span>
                                                                        </a>

                                                                    </li>
                                                                    <li>
                                                                        <a
                                                                            (click)="onDownloadClick('bottom'); mobileMenues = false">
                                                                            <span
                                                                                class="flex align-items-center gap-2 w-full">

                                                                                <span class="mainMenueTitle">
                                                                                    List Yourself
                                                                                </span>

                                                                            </span>
                                                                        </a>

                                                                    </li>

                                                                    <li>
                                                                        <a
                                                                            (click)="onDownloadClick('bottom'); mobileMenues = false">
                                                                            <span
                                                                                class="flex align-items-center gap-2 w-full">

                                                                                <span class="mainMenueTitle">
                                                                                    My Schedule
                                                                                </span>

                                                                            </span>
                                                                        </a>

                                                                    </li>


                                                                </ul>

                                                            </p-accordionTab>
                                                        </p-accordion>
                                                    </li> -->
                                                    <!-- <li>
                                                        <p-accordion>
                                                            <p-accordionTab>
                                                                <ng-template pTemplate="header">
                                                                    <span class="flex align-items-center gap-2 w-full">
                                                                        <div class="icon">
                                                                            <img src="../../../assets/images/header/m-IconContest.svg"
                                                                                alt="">
                                                                        </div>
                                                                        <span class="mainMenueTitle">
                                                                            Contests
                                                                        </span>

                                                                    </span>
                                                                </ng-template>

                                                                <ul class="subMenueslist">
                                                                    <li>
                                                                        <a routerLink="/contest "
                                                                            (click)="mobileMenues = false">
                                                                            <span
                                                                                class="flex align-items-center gap-2 w-full">

                                                                                <span class="mainMenueTitle">
                                                                                    All Contests
                                                                                </span>

                                                                            </span>
                                                                        </a>

                                                                    </li>
                                                                    <li>
                                                                        <a routerLink="/contest-history "
                                                                            (click)="mobileMenues = false">
                                                                            <span
                                                                                class="flex align-items-center gap-2 w-full">

                                                                                <span class="mainMenueTitle">
                                                                                    My Contests
                                                                                </span>

                                                                            </span>
                                                                        </a>

                                                                    </li>
                                                                    <li>
                                                                        <a routerLink="contest-leaderboard"
                                                                            (click)="mobileMenues = false">
                                                                            <span
                                                                                class="flex align-items-center gap-2 w-full">

                                                                                <span class="mainMenueTitle">
                                                                                    Leaderboard
                                                                                </span>

                                                                            </span>
                                                                        </a>

                                                                    </li>

                                                                </ul>

                                                            </p-accordionTab>
                                                        </p-accordion>
                                                    </li> -->
                                                    <li>
                                                        <!-- <a routerLink="leaderboard" (click)="mobileMenues = false"> -->
                                                        <a (click)="onDownloadClick('bottom'); mobileMenues = false">
                                                            <div class="menuesList">
                                                                <div class="icon">
                                                                    <img src="../../../assets/images/header/m-Iconrank.svg"
                                                                        alt="">
                                                                </div>
                                                                <div class="title">

                                                                    <span>Rankings</span>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a (click)="onDownloadClick('bottom'); mobileMenues = false">
                                                            <div class="menuesList">
                                                                <div class="icon">
                                                                    <img src="../../../assets/images/header/m-IconEstore.svg"
                                                                        alt="">
                                                                </div>
                                                                <div class="title">

                                                                    <span>E-Store</span>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a routerLink="race-to-gold" (click)="mobileMenues = false">
                                                            <div class="menuesList">
                                                                <div class="icon">
                                                                    <img src="../../../assets/images/header/m-Iconrace.svg"
                                                                        alt="">
                                                                </div>
                                                                <div class="title">

                                                                    <span>Race to Gold</span>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a (click)="onDownloadClick('bottom'); mobileMenues = false">
                                                            <div class="menuesList">
                                                                <div class="icon">
                                                                    <img src="../../../assets/images/header/m-IconLive.svg"
                                                                        alt="">
                                                                </div>
                                                                <div class="title">

                                                                    <span>Live Score</span>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <!-- <li>
                                                        <a (click)="onDownloadClick('bottom'); mobileMenues = false">
                                                            <div class="menuesList">
                                                                <div class="icon">
                                                                    <img src="../../../assets/images/header/m-Iconreddem.svg"
                                                                        alt="">
                                                                </div>
                                                                <div class="title">

                                                                    <span>Redeem Rewards</span>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </li> -->
                                                    <li>
                                                        <p-accordion>
                                                            <p-accordionTab>
                                                                <ng-template pTemplate="header">
                                                                    <span class="flex align-items-center gap-2 w-full">
                                                                        <div class="icon">
                                                                            <img src="../../../assets/images/header/m-IconInfo.svg"
                                                                                alt="">
                                                                        </div>
                                                                        <span class="mainMenueTitle">
                                                                            Information
                                                                        </span>

                                                                    </span>
                                                                </ng-template>

                                                                <ul class="subMenueslist">
                                                                    <li>
                                                                        <a routerLink="termsandcondition"
                                                                            (click)="mobileMenues = false">
                                                                            <span
                                                                                class="flex align-items-center gap-2 w-full">

                                                                                <span class="mainMenueTitle">
                                                                                    Terms and Conditions
                                                                                </span>

                                                                            </span>
                                                                        </a>

                                                                    </li>
                                                                    <li>
                                                                        <a routerLink="refund-policy"
                                                                            (click)="mobileMenues = false">
                                                                            <span
                                                                                class="flex align-items-center gap-2 w-full">

                                                                                <span class="mainMenueTitle">
                                                                                    Refund Policy
                                                                                </span>

                                                                            </span>
                                                                        </a>

                                                                    </li>
                                                                    <li>
                                                                        <a routerLink="data-protection-policy"
                                                                            (click)="mobileMenues = false">
                                                                            <span
                                                                                class="flex align-items-center gap-2 w-full">

                                                                                <span class="mainMenueTitle">
                                                                                    Data Protection Policy
                                                                                </span>

                                                                            </span>
                                                                        </a>

                                                                    </li>
                                                                    <li>
                                                                        <a routerLink="privacy-policy"
                                                                            (click)="mobileMenues = false">
                                                                            <span
                                                                                class="flex align-items-center gap-2 w-full">

                                                                                <span class="mainMenueTitle">
                                                                                    Privacy Policy
                                                                                </span>

                                                                            </span>
                                                                        </a>

                                                                    </li>
                                                                    <li>
                                                                        <a routerLink="cookie-policy"
                                                                            (click)="mobileMenues = false">
                                                                            <span
                                                                                class="flex align-items-center gap-2 w-full">

                                                                                <span class="mainMenueTitle">
                                                                                    Cookie Policy
                                                                                </span>

                                                                            </span>
                                                                        </a>

                                                                    </li>
                                                                    <li>
                                                                        <a routerLink="contact-us"
                                                                            (click)="mobileMenues = false">
                                                                            <span
                                                                                class="flex align-items-center gap-2 w-full">

                                                                                <span class="mainMenueTitle">
                                                                                    Help & Support
                                                                                </span>

                                                                            </span>
                                                                        </a>

                                                                    </li>

                                                                </ul>

                                                            </p-accordionTab>
                                                        </p-accordion>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </p-overlayPanel>
                    </div>

                </div>
            </div>
            <div class="headerBottom">
                <ul class=" d-flex menues-list">
                    <li>
                        <a [routerLinkActive]="'active'" routerLink="about-the-league">
                            ABOUT TPL
                        </a>
                    </li>
                    <li>
                        <a [routerLinkActive]="'active'" routerLink="tournaments" (click)="onNavigateToTournaments()">
                            TOURNAMENTS
                        </a>
                    </li>
                    <li>
                        <a class="cursor-pointer" (click)="onDownloadClick('bottom')">
                            book a court
                        </a>
                    </li>
                    <li>
                        <a [routerLinkActive]="'active'" routerLink="academies">
                            ACADEMIES
                        </a>
                    </li>

                    <li>
                        <a [routerLinkActive]="'active'" routerLink="find-partner">
                            FIND A PARTNER
                        </a>
                    </li>
                    <li>
                        <!-- <a [routerLinkActive]="'active'" routerLink="product" [queryParams]="{ page: 1, limit: 10 }"> -->
                        <a  class="cursor-pointer"  (click)="onDownloadClick('bottom'); mobileMenues = false">
                            E-Store
                        </a>
                    </li>
                    <li>
                        <!-- <a [routerLinkActive]="'active'" routerLink="leaderboard" -->
                        <a  class="cursor-pointer"  [routerLinkActive]="'active'" (click)="onDownloadClick('bottom'); mobileMenues = false">
                            Rankings
                        </a>
                    </li>
                </ul>
            </div>

        </div>
    </div>
</header>


<!-- Button trigger modal -->


<!-- Modal -->
<div class="modal fade left" id="mobile-menu" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
    [ngClass]="isAcademy ? 'academy-user ' : ''">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header" *ngIf="isLoggedIn">
                <ul *ngIf="isLoggedIn">
                    <li class=" dropdown user-account-page">
                        <div class=" media user-div">
                            <div class="media-left">
                                <div class="user-image">
                                    <img [src]="(loggedInProfilePic.length !== 0) ? loggedInProfilePic : '../../../../assets/images/academy_dummy.jpg'"
                                        alt="">
                                </div>
                            </div>
                            <div class="media-body">
                                <h1>{{loggedInUsername}}</h1>
                            </div>
                            <div class="media-right">
                                <div *ngIf="!isAcademy" class="viewProfile-btn">
                                    <a class=" nav-link scrollto" (click)="activeIndex = 1"
                                        style="color: #fff!important;">
                                        View Profile <span><i class='pi pi-chevron-right'
                                                style="font-size: 1rem;"></i></span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="hover-div ">
                            <ul>
                                <li data-bs-dismiss="modal" *ngIf="!isAcademy" routerLink="profile-info">
                                    <a routerLink="profile-info"><span><i class='bx bx-user'></i> My Profile</span></a>
                                </li>
                                <li data-bs-dismiss="modal" *ngIf="!isAcademy" routerLink="my-wallet">
                                    <a routerLink="my-wallet"><span><i class='bx bx-wallet-alt'></i> My
                                            Wallet</span></a>
                                </li>
                                <li data-bs-dismiss="modal" *ngIf="!isAcademy && this.item?.age >=18"
                                    routerLink="bank-details">
                                    <a routerLink="bank-details"><span><i class='bx bxs-bank'></i> Bank
                                            Settings</span></a>
                                </li>
                                <li data-bs-dismiss="modal" *ngIf="isAcademy && showAcademymenu" routerLink="academies-profile">
                                    <a routerLink="academies-profile"><span><i class='bx bxs-graduation'></i>
                                            Academy</span></a>
                                </li>
                                <li data-bs-dismiss="modal" *ngIf="isAcademy" routerLink="payment-history">
                                    <a routerLink="payment-history">
                                        <span><i class='bx bx-time'></i> Payment History</span>
                                    </a>
                                </li>
                                <li data-bs-dismiss="modal">
                                    <a (click)="signOut()"><span><i class='bx bx-log-out-circle'></i> Logout</span></a>
                                </li>
                            </ul>
                        </div> -->
                    </li>
                </ul>
            </div>
            <div class="modal-wallet" *ngIf="isLoggedIn && !isAcademy">
                <div class="media wallet-menue-mobile-div">
                    <div class="media-left">
                        <div class="icon">
                            <img src="../../../assets/img/home/wallet.svg" alt="">
                        </div>
                    </div>
                    <div class="media-body">
                        <span>My Balance</span>
                    </div>
                    <div class="media-right">
                        <h2>₹{{totalAvailableCash | number:'1.2-2'}}</h2>
                    </div>
                </div>
                <div class="add-button-modal" data-bs-dismiss="modal">
                    <button routerLink="/my-wallet">ADD CASH</button>
                </div>
            </div>
            <div class="modal-body">
                <div class="col-md-12">
                    <p-tabView *ngIf="isLoggedIn" [(activeIndex)]="activeIndex">
                        <p-tabPanel>
                            <ng-template pTemplate="header" *ngIf="isLoggedIn" class="home-header-menue">
                                <i class="pi pi-home"></i>
                                <span>Home Menus</span>
                            </ng-template>
                            <div class="mobile-menue">
                                <div class="close-icon">
                                    <button data-bs-dismiss="modal"><i class='bx bx-x'></i></button>
                                </div>
                                <ul>
                                    <li data-bs-dismiss="modal" class="refer-list-ui">
                                        <a [routerLinkActive]="'active'" routerLink="refer-earn"
                                            class="nav-link scrollto">
                                            <img src="../../../assets/img/home/m1.svg" alt=""
                                                style="filter: invert(48%) sepia(97%) saturate(3%) hue-rotate(319deg) brightness(90%) contrast(88%);">
                                            <span>Refer & Earn</span>
                                        </a>
                                    </li>
                                    <li class="mobile-versiontabmenue">
                                        <p-accordion class="w-full">
                                            <p-accordionTab>
                                                <ng-template pTemplate="header">
                                                    <div class="flex align-items-center">
                                                        <span class="vertical-align-middle">

                                                            <img src="../../../assets/img/home/m2.svg" alt=""
                                                                style="filter: invert(48%) sepia(97%) saturate(3%) hue-rotate(319deg) brightness(90%) contrast(88%);">
                                                            contests
                                                        </span>
                                                    </div>
                                                </ng-template>
                                                <ng-template pTemplate="content">
                                                    <ul style=" padding-left: 1.6rem;">
                                                        <li data-bs-dismiss="modal"><a [routerLinkActive]="'active' "
                                                                routerLink="contest"><i class='bx bx bx-group'></i>
                                                                contest</a>
                                                        </li>
                                                        <li *ngIf="isLoggedIn && !isAcademy " data-bs-dismiss="modal"><a
                                                                [routerLinkActive]="'active' "
                                                                routerLink="contest-history"
                                                                (click)="onNavigateToMyContest()"><i
                                                                    class='bx bx bx-group'></i> my contest </a>
                                                        </li>
                                                        <li data-bs-dismiss="modal"><a [routerLinkActive]="'active' "
                                                                routerLink="contest-leaderboard">
                                                                <i class='bx bx-user-pin'></i> leaderboard</a>
                                                        </li>
                                                    </ul>
                                                </ng-template>
                                            </p-accordionTab>
                                        </p-accordion>
                                    </li>
                                    <li data-bs-dismiss="modal">
                                        <a [routerLinkActive]="'active'" routerLink="tournaments"
                                            (click)="onNavigateToTournaments()" class=" nav-link scrollto">
                                            <img src="../../../assets/img/home/m3.svg" alt=""
                                                style="filter: invert(48%) sepia(97%) saturate(3%) hue-rotate(319deg) brightness(90%) contrast(88%);">
                                            tournaments</a>
                                    </li>
                                    <li data-bs-dismiss="modal"><a [routerLinkActive]="'active'"
                                            routerLink="leaderboard" class=" nav-link scrollto">
                                            <img src="../../../assets/img/home/m4.svg" alt=""
                                                style="filter: invert(48%) sepia(97%) saturate(3%) hue-rotate(319deg) brightness(90%) contrast(88%);">
                                            Rankings</a>
                                    </li>
                                    <li data-bs-dismiss="modal">
                                        <a [routerLinkActive]="'active'" class=" nav-link scrollto"
                                            routerLink="race-to-gold">
                                            <img src="../../../assets/img/home/m5.svg" alt=""
                                                style="filter: invert(48%) sepia(97%) saturate(3%) hue-rotate(319deg) brightness(90%) contrast(88%);">
                                            Race To Gold</a>
                                    </li>
                                    <li data-bs-dismiss="modal">
                                        <a [routerLinkActive]="'active'" routerLink="academies"
                                            class=" nav-link scrollto">
                                            <img src="../../../assets/img/home/m6.svg" alt=""
                                                style="filter: invert(48%) sepia(97%) saturate(3%) hue-rotate(319deg) brightness(90%) contrast(88%);">
                                            academies</a>
                                    </li>

                                    <li class="mobile-versiontabmenue">
                                        <p-accordion class="w-full">
                                            <p-accordionTab>
                                                <ng-template pTemplate="header">
                                                    <div class="flex align-items-center">
                                                        <span class="vertical-align-middle">
                                                            <img src="../../../assets/img/home/m7.svg" alt=""
                                                                style="filter: invert(48%) sepia(97%) saturate(3%) hue-rotate(319deg) brightness(90%) contrast(88%);">
                                                            find a partner
                                                        </span>
                                                    </div>
                                                </ng-template>
                                                <ng-template pTemplate="content">
                                                    <ul style=" padding-left: 1.6rem;" class="findApartner-list">
                                                        <li *ngFor="let value of usercategories"
                                                            data-bs-dismiss="modal">
                                                            <a (click)="onClick(value.id)" [value]="value.id"
                                                                class="menues-list">
                                                                <i class='bx '>
                                                                    <img src="assets/img/login/icon-player2.svg" alt=""
                                                                        style="height: 20px; margin-top: -12px; filter: invert(48%) sepia(97%) saturate(3%) hue-rotate(319deg) brightness(90%) contrast(88%);">
                                                                </i>
                                                                <i class='bx'>
                                                                    <img src="assets/img/login/icon-player.svg" alt=""
                                                                        style="height: 20px; margin-top: -12px; filter: invert(48%) sepia(97%) saturate(3%) hue-rotate(319deg) brightness(90%) contrast(88%);">
                                                                </i>
                                                                <i class='bx '>
                                                                    <img src="assets/img/login/icon-player3.svg" alt=""
                                                                        style="height: 20px; margin-top: -12px; filter: invert(48%) sepia(97%) saturate(3%) hue-rotate(319deg) brightness(90%) contrast(88%);">
                                                                </i>
                                                                {{value.user_role_description}}
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </ng-template>
                                            </p-accordionTab>
                                        </p-accordion>
                                    </li>

                                    <li data-bs-dismiss="modal"><a [routerLinkActive]="'active' "
                                            class="nav-link scrollto" routerLink="product">
                                            <img src="../../../assets/img/home/m8.svg" alt=""
                                                style="filter: invert(48%) sepia(97%) saturate(3%) hue-rotate(319deg) brightness(90%) contrast(88%);">
                                            shop</a></li>
                                    <li class="mobile-versiontabmenue">

                                        <p-accordion class="w-full">
                                            <p-accordionTab>
                                                <ng-template pTemplate="header">
                                                    <div class="flex align-items-center">
                                                        <span class="vertical-align-middle"> <i
                                                                class='bx bx-info-circle'></i> about TPL </span>
                                                    </div>
                                                </ng-template>
                                                <ng-template pTemplate="content">
                                                    <ul style=" padding-left: 1.6rem;">
                                                        <li data-bs-dismiss="modal"><a [routerLinkActive]="'active' "
                                                                routerLink="about-the-league"> <i
                                                                    class='bx bx-info-circle'></i> about the League</a>
                                                        </li>
                                                        <li data-bs-dismiss="modal"><a [routerLinkActive]="'active' "
                                                                routerLink="scoretable"><i class='bx bx-table'></i> TPL
                                                                Team standing</a></li>
                                                        <li data-bs-dismiss="modal"><a [routerLinkActive]="'active' "
                                                                routerLink="teams"><i
                                                                    class='bx bxl-microsoft-teams'></i>teams</a></li>
                                                        <li data-bs-dismiss="modal"><a [routerLinkActive]="'active' "
                                                                routerLink="sponsors"><i class='bx bxs-shapes'></i>
                                                                sponsors</a>
                                                        </li>
                                                        <li data-bs-dismiss="modal"><a [routerLinkActive]="'active' "
                                                                routerLink="media"><i class='bx bx-image'></i> media</a>
                                                        </li>
                                                        <li data-bs-dismiss="modal"><a [routerLinkActive]="'active' "
                                                                routerLink="highlights"><i class='bx bxs-videos'></i>
                                                                highlights</a> </li>
                                                    </ul>
                                                </ng-template>
                                            </p-accordionTab>
                                        </p-accordion>
                                    </li>


                                    <li>
                                        <a [routerLinkActive]="'active'" class=" nav-link scrollto"
                                            (click)="showInformationlist()">
                                            <img src="../../../assets/img/home/m9.svg" alt=""
                                                style="filter: invert(48%) sepia(97%) saturate(3%) hue-rotate(319deg) brightness(90%) contrast(88%);">

                                            Information</a>
                                    </li>

                                    <ul class="information-list "
                                        [ngClass]="informationList ? 'showList-menue ' : 'hideList-menue'">
                                        <li class="back-button-list" (click)="backInformationBtn()">
                                            <span class="BackIcon">
                                                <i class='bx bx-chevron-left'></i>
                                            </span>
                                            Information
                                        </li>
                                        <li>
                                            <a [routerLinkActive]="'active'" [routerLink]="['/faq']"
                                                class=" nav-link scrollto" data-bs-dismiss="modal">
                                                <i class='bx bx-question-mark' style="font-size: 22px;"></i>
                                                FAQs</a>
                                        </li>
                                        <li>
                                            <a [routerLinkActive]="'active'" [routerLink]="['/termsandcondition']"
                                                class=" nav-link scrollto" data-bs-dismiss="modal">
                                                <i class='bx bx-check-square' style="font-size: 22px;"></i>
                                                Terms and Conditions</a>
                                        </li>
                                        <li>
                                            <a [routerLinkActive]="'active'" [routerLink]="['/refund-policy']"
                                                class=" nav-link scrollto" data-bs-dismiss="modal">
                                                <i class='bx bx-spreadsheet' style="font-size: 22px;"></i>
                                                Refund Policy</a>
                                        </li>

                                        <li>
                                            <a [routerLinkActive]="'active'" [routerLink]="['/data-protection-policy']"
                                                class=" nav-link scrollto" data-bs-dismiss="modal">
                                                <i class='bx bx-lock-alt' style="font-size: 22px;"></i>
                                                Data Protection Policy</a>
                                        </li>
                                        <li>
                                            <a [routerLinkActive]="'active'" [routerLink]="['/privacy-policy']"
                                                class=" nav-link scrollto" data-bs-dismiss="modal">
                                                <i class='bx bx-check-shield' style="font-size: 22px;"></i>
                                                Privacy Policy</a>
                                        </li>
                                        <li>
                                            <a [routerLinkActive]="'active'" [routerLink]="['/cookie-policy']"
                                                class=" nav-link scrollto" data-bs-dismiss="modal">
                                                <i class='bx bx-cookie' style="font-size: 22px;"></i>
                                                Cookie Policy</a>

                                        </li>
                                        <li>
                                            <a [routerLinkActive]="'active'" [routerLink]="['/contact-us']"
                                                class=" nav-link scrollto" data-bs-dismiss="modal">
                                                <i class='bx bx-support' style="font-size: 22px;"></i>
                                                Contact Us</a>
                                        </li>
                                    </ul>

                                </ul>
                            </div>
                        </p-tabPanel>
                        <!-- <p-tabPanel *ngIf="doSecondTabDisplay"> -->
                        <p-tabPanel>
                            <ng-template pTemplate="header" *ngIf="!isAcademy" class="profile-header">
                                <i class="pi pi-user"></i>
                                <span>Profile</span>
                            </ng-template>
                            <!-- <ng-template pTemplate="header" *ngIf="isAcademy && showAcademymenu"> -->
                            <ng-template pTemplate="header" *ngIf="isAcademy ">
                                <i class="pi pi-building"></i>
                                <span>Academy</span>
                            </ng-template>

                            <div class="mobile-menue">
                                <!--Modal close button-->
                                <div class="close-icon">
                                    <button data-bs-dismiss="modal"><i class='bx bx-x'></i></button>
                                </div>
                                <!--Modal close button-->

                                <!--Only User menus--->
                                <ul *ngIf="!isAcademy" class="user-profile-menu">
                                    <!-- <div class="menue-back-btn">
                                        <div class="media">
                                            <div class="media-left">
                                                <i class="pi pi-arrow-left "></i>

                                            </div>
                                            <div class="media-body">
                                                back To Home menus
                                            </div>
                                        </div>
                                    </div> -->
                                    <div class="menue-back-btn">
                                        <button (click)="activeIndex = 0">
                                            <span class="BackIcon">
                                                <i class='bx bx-chevron-left'></i>
                                            </span>
                                            PROFILE
                                        </button>
                                    </div>

                                    <li class="active" data-bs-dismiss="modal"><a [routerLinkActive]="'active' "
                                            routerLink="../profile-info" class="nav-link scrollto"> <i
                                                class='bx bx-grid-horizontal'></i> Information</a></li>

                                    <li data-bs-dismiss="modal"><a [routerLinkActive]="'active' "
                                            routerLink="../profile-skills" class="nav-link scrollto "> <i
                                                class='bx bx-bar-chart-square'></i> Skill </a>
                                    </li>

                                    <li data-bs-dismiss="modal"><a [routerLinkActive]="'active' "
                                            routerLink="../profile-ranking" class="nav-link scrollto"><i
                                                class='bx bx-bar-chart'></i>Ranking </a></li>
                                    <li data-bs-dismiss="modal"><a [routerLinkActive]="'active' "
                                            routerLink="../profile-matches" class="nav-link scrollto"><i
                                                class='bx bx-trophy'></i> Matches </a></li>
                                    <li data-bs-dismiss="modal"><a [routerLinkActive]="'active' "
                                            routerLink="../profile-opponents" class="nav-link scrollto"><i> <img
                                                    src="../../../assets/img/icon/opp-icon.svg" alt=""
                                                    style="width: 22px;  height: 22px; object-fit: contain; filter: invert(57%) sepia(2%) saturate(30%) hue-rotate(15deg) brightness(91%) contrast(94%);">
                                            </i>
                                            Opponents </a>
                                    </li>
                                    <li data-bs-dismiss="modal"><a [routerLinkActive]="'active' "
                                            routerLink="../my-achivements" class="nav-link scrollto"><i
                                                class='bx bx-id-card'></i> My Achievements </a></li>
                                    <li data-bs-dismiss="modal"><a [routerLinkActive]="'active' "
                                            routerLink="../profile-tournament" class="nav-link scrollto"><i
                                                class='bx bxs-flag-checkered'></i> My Tournaments </a></li>


                                    <!-- <li class="mobile-versiontabmenue">
                                        <p-accordion class="w-full">
                                            <p-accordionTab>
                                                <ng-template pTemplate="header">
                                                    <div class="flex align-items-center">
                                                        <span class="vertical-align-middle"><i
                                                                class='bx bxs-flag-checkered'></i> My Tournaments
                                                        </span>
                                                    </div>
                                                </ng-template>
                                                <ng-template pTemplate="content">
                                                    <ul style=" padding-left: 1.6rem;">
                                                        <li data-bs-dismiss="modal"><a [routerLinkActive]="'active' " routerLink="../profile-tournament">
                                                            <i class='bx bx-shape-polygon'></i> My Tournaments</a>
                                                        </li>
                                                        <li data-bs-dismiss="modal">
                                                            <a [routerLinkActive]="'active' " routerLink="../my-achivements"> <i class='bx bx-id-card'></i> My Achievements</a> 
                                                        </li> 
                                                    </ul>
                                                </ng-template>
                                            </p-accordionTab>
                                        </p-accordion>
                                    </li>  -->
                                    <!-- <li data-bs-dismiss="modal"><a [routerLinkActive]="'active' "
                                            routerLink="../profile-tournament" class="nav-link scrollto"><i 
                                            class='bx bxs-flag-checkered'></i>My Tournaments
                                        </a></li> -->
                                    <li class="" data-bs-dismiss="modal">
                                        <a [routerLinkActive]="'active' " routerLink="../profile-request"
                                            class="nav-link scrollto">
                                            <i class='bx bx-git-pull-request'></i> Partner Request
                                        </a>
                                    </li>
                                    <li class="" data-bs-dismiss="modal"><a [routerLinkActive]="'active' "
                                            routerLink="../contest-history" (click)="onNavigateToMyContest()"
                                            class="nav-link scrollto">
                                            <i class='bx bx-medal' style="font-size: 22px;margin-right: -2px;"></i>
                                            Contest History
                                        </a>
                                    </li>
                                    <li *ngIf="!isAcademy && this.item?.age >=18" data-bs-dismiss="modal"><a
                                            [routerLinkActive]="'active' " routerLink="bank-details"
                                            class="nav-link scrollto">
                                            <i class='bx bxs-bank' style="font-size: 22px;margin-right: -2px;"></i>
                                            Bank Settings
                                        </a>
                                    </li>
                                    <li data-bs-dismiss="modal"><a [routerLinkActive]="'active' "
                                            *ngIf="currentDate <= passEndDate" routerLink="../player-ticket"
                                            class="nav-link scrollto"> <i class='bx bx-barcode'></i> My Tickets</a>
                                    </li>

                                    <!-- <li><a href="membership.html" class="nav-link scrollto">Memberships </a></li> -->
                                </ul>

                                <!--End User menus--->

                                <!--Only academy menus--->
                                <!-- <ul *ngIf="isAcademy && showAcademymenu"> -->
                                <ul *ngIf="isAcademy">
                                    <li class="active" data-bs-dismiss="modal"><a routerLink="/academies-profile"
                                            [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact:true}"
                                            class="nav-link scrollto"><i class='bx bx-grid-horizontal'></i>
                                            Information</a>
                                    </li>
                                    <li data-bs-dismiss="modal"><a routerLink="/academies-profile/highlights"
                                            [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact:true}"
                                            class="nav-link scrollto "><i class='bx bx-list-ul'></i> Wow Factor </a>
                                    </li>

                                    <li data-bs-dismiss="modal"><a routerLink="/academies-profile/top-players"
                                            [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact:true}"
                                            class="nav-link scrollto"><i class='bx bx-run'></i> Top Players </a></li>
                                    <li data-bs-dismiss="modal"><a routerLink="/academies-profile/courts"
                                            [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact:true}"
                                            class="nav-link scrollto"><i class='bx bx-book-content'></i> Courts</a></li>

                                    <li data-bs-dismiss="modal"><a routerLink="/academies-profile/branches"
                                            class="nav-link scrollto"><i class='bx bx-pyramid'></i> Branches
                                        </a></li>
                                    <li class="" data-bs-dismiss="modal"><a routerLink="/academies-profile/coaches"
                                            [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact:true}"
                                            class="nav-link scrollto"><i class='bx bx-user-voice'></i> Coaches
                                        </a>
                                    </li>
                                    <li class="" data-bs-dismiss="modal"><a class="nav-link scrollto"
                                            routerLink="/academies-profile/our-tournaments"
                                            [routerLinkActive]="'active'"><i class='bx bx-list-plus'></i>Our Tournament
                                        </a>
                                    </li>
                                    <li class="" data-bs-dismiss="modal"><a class="nav-link scrollto"
                                            routerLink="/reviews" [routerLinkActive]="'active'"><i
                                                class='pi pi-comment'></i>Academy Reviews <p-badge
                                                [value]="academyReviewCount"></p-badge>
                                        </a>
                                    </li>
                                    <li class="" data-bs-dismiss="modal"><a class="nav-link scrollto"
                                            routerLink="/payment-history" [routerLinkActive]="'active'"><i
                                                class='bx bx-time'></i>Payment history
                                        </a>
                                    </li>


                                    <!-- <li><a href="membership.html" class="nav-link scrollto">Memberships </a></li> -->


                                </ul>
                                <!--End academy menus--->
                            </div>
                        </p-tabPanel>

                    </p-tabView>

                    <!--Normal menue-->
                    <div class="mobile-menue" *ngIf="!isLoggedIn">
                        <div class="close-icon">
                            <button data-bs-dismiss="modal"><i class='bx bx-x'></i></button>
                        </div>
                        <ul>
                            <li data-bs-dismiss="modal">
                                <a [routerLinkActive]="'active'" routerLink="refer-earn" class=" nav-link scrollto">
                                    <i class='bx bx-user-plus' style="font-size: 22px;"></i>
                                    Refer & Earn</a>
                            </li>
                            <!-- <li class="mobile-versiontabmenue">
                                <p-accordion class="w-full">
                                    <p-accordionTab>
                                        <ng-template pTemplate="header">
                                            <div class="flex align-items-center">
                                                <span class="vertical-align-middle">
                                                    <i class='bx bx bx-group'></i> Contests
                                                </span>
                                            </div>
                                        </ng-template>
                                        <ng-template pTemplate="content">
                                            <ul style=" padding-left: 1.6rem;">
                                                <li data-bs-dismiss="modal"><a [routerLinkActive]="'active' "
                                                        routerLink="contest"><i class='bx bx bx-group'></i> Contests</a>
                                                </li>
                                                <li *ngIf="isLoggedIn" data-bs-dismiss="modal"><a
                                                        [routerLinkActive]="'active' " routerLink="contest-history"
                                                        (click)="onNavigateToMyContest()"><i class='bx bx bx-group'></i>
                                                        MY
                                                        Contests</a>
                                                </li>
                                                <li data-bs-dismiss="modal">
                                                    <a [routerLinkActive]="'active'" routerLink="contest-leaderboard">
                                                        <i class='bx bx-user-pin'></i> Leaderboard</a>
                                                </li>
                                            </ul>
                                        </ng-template>
                                    </p-accordionTab>
                                </p-accordion>
                            </li> -->
                            <li data-bs-dismiss="modal"><a class="nav-link scrollto " [routerLinkActive]="'active'"
                                    routerLink="tournaments" (click)="onNavigateToTournaments()">
                                    <i class="bx bx-tennis-ball"></i>
                                    Tournaments</a></li>
                            <li class="mobile-versiontabmenue">
                                <p-accordion class="w-full">
                                    <p-accordionTab>
                                        <ng-template pTemplate="header">
                                            <div class="flex align-items-center">
                                                <span class="vertical-align-middle">
                                                    <i class='bx bx-search'></i> Find A Partner
                                                </span>
                                            </div>
                                        </ng-template>
                                        <ng-template pTemplate="content">
                                            <ul style=" padding-left: 1.6rem;" class="findApartner-list">
                                                <li *ngFor="let value of usercategories" data-bs-dismiss="modal">
                                                    <a (click)="onClick(value.id)" [value]="value.id"
                                                        class="menues-list">
                                                        <i class='bx'>
                                                            <img src="assets/img/login/icon-player2.svg" alt=""
                                                                style="height: 20px; margin-top: -12px;">
                                                        </i>
                                                        <i class='bx'>
                                                            <img src="assets/img/login/icon-player.svg" alt=""
                                                                style="height: 20px; margin-top: -12px;">
                                                        </i>
                                                        <i class='bx'>
                                                            <img src="assets/img/login/icon-player3.svg" alt=""
                                                                style="height: 20px; margin-top: -12px;">
                                                        </i>
                                                        {{value.user_role_description}}
                                                    </a>
                                                </li>

                                            </ul>
                                        </ng-template>
                                    </p-accordionTab>
                                </p-accordion>
                            </li>
                            <li data-bs-dismiss="modal">
                                <a routerLink="academies" [routerLinkActive]="'active'" class=" nav-link scrollto">
                                    <i class="bx bxs-school"></i> Academies</a>
                            </li>
                            <li data-bs-dismiss="modal"><a [routerLinkActive]="'active'" routerLink="leaderboard"
                                    class=" nav-link scrollto">
                                    <i class='bx bx-bar-chart-alt'></i> Rankings</a>
                            </li>
                            <li data-bs-dismiss="modal"><a class="nav-link scrollto" routerLink="product"
                                    [routerLinkActive]="'active'">
                                    <i class='bx bx-shopping-bag'></i> E-Store</a>
                            </li>
                            <li class="mobile-versiontabmenue">
                                <p-accordion class="w-full">
                                    <p-accordionTab>
                                        <ng-template pTemplate="header">
                                            <div class="flex align-items-center">
                                                <span class="vertical-align-middle">
                                                    <i class='bx bx-info-circle'></i>
                                                    About TPL </span>
                                            </div>
                                        </ng-template>
                                        <ng-template pTemplate="content">
                                            <ul style="padding-left: 1.6rem;">
                                                <li data-bs-dismiss="modal"><a [routerLinkActive]="'active' "
                                                        routerLink="about-the-league"><i class='bx bx-info-circle'></i>
                                                        About The League</a> </li>
                                                <li data-bs-dismiss="modal"><a [routerLinkActive]="'active' "
                                                        routerLink="scoretable"><i class='bx bx-table'></i> TPL Teams
                                                        Standings
                                                        Table</a></li>
                                                <li data-bs-dismiss="modal"><a [routerLinkActive]="'active' "
                                                        routerLink="teams"><i class='bx bxl-microsoft-teams'></i>
                                                        Teams</a></li>
                                                <li data-bs-dismiss="modal"><a [routerLinkActive]="'active' "
                                                        routerLink="sponsors"><i class='bx bxs-shapes'></i> Sponsors</a>
                                                </li>
                                                <li data-bs-dismiss="modal"><a [routerLinkActive]="'active' "
                                                        routerLink="media"><i class='bx bx-image'></i> Media</a> </li>
                                                <li data-bs-dismiss="modal"><a [routerLinkActive]="'active' "
                                                        routerLink="highlights"><i class='bx bxs-videos'></i>
                                                        Highlights</a> </li>
                                            </ul>
                                        </ng-template>
                                    </p-accordionTab>


                                </p-accordion>
                            </li>


                            <li>
                                <!-- <a [routerLink]="'/refer-earn'" [routerLinkActive]="'active'">
                                                                                <span><i class='bx bx-user-plus' style="font-size: 20px;"></i> Refer & Earn</span>
                                                                            </a> -->
                                <a [routerLinkActive]="'active'" class=" nav-link scrollto"
                                    (click)="showInformationlist()">
                                    <i class='bx bx-category' style="font-size: 22px;"></i>
                                    Information</a>
                            </li>
                            <li data-bs-dismiss="modal">
                                <a [routerLinkActive]="'active'" routerLink="race-to-gold" class=" nav-link scrollto">
                                    <i class='bx bx-gift' style="font-size: 22px;"></i>
                                    Race To Gold</a>
                            </li>
                            <!-- <li><a class="nav-link scrollto" routerLink="contact-us">CONTACT US</a></li> -->

                            <ul class="information-list "
                                [ngClass]="informationList ? 'showList-menue ' : 'hideList-menue'">
                                <li class="back-button-list" (click)="backInformationBtn()">
                                    <span class="BackIcon">
                                        <i class='bx bx-chevron-left'></i>
                                    </span>
                                    Information
                                </li>
                                <li>
                                    <a [routerLinkActive]="'active'" [routerLink]="['/faq']" class=" nav-link scrollto"
                                        data-bs-dismiss="modal">
                                        <i class='bx bx-question-mark' style="font-size: 22px;"></i>
                                        FAQs</a>
                                </li>
                                <li>
                                    <a [routerLinkActive]="'active'" [routerLink]="['/termsandcondition']"
                                        class=" nav-link scrollto" data-bs-dismiss="modal">
                                        <i class='bx bx-check-square' style="font-size: 22px;"></i>
                                        Terms and Conditions</a>
                                </li>

                                <li>
                                    <a [routerLinkActive]="'active'" [routerLink]="['/refund-policy']"
                                        class=" nav-link scrollto" data-bs-dismiss="modal">
                                        <i class='bx bx-spreadsheet' style="font-size: 22px;"></i>
                                        Refund Policy</a>
                                </li>

                                <li>
                                    <a [routerLinkActive]="'active'" [routerLink]="['/data-protection-policy']"
                                        class=" nav-link scrollto" data-bs-dismiss="modal">
                                        <i class='bx bx-lock-alt' style="font-size: 22px;"></i>
                                        Data Protection Policy</a>
                                </li>
                                <li>
                                    <a [routerLinkActive]="'active'" [routerLink]="['/privacy-policy']"
                                        class=" nav-link scrollto" data-bs-dismiss="modal">
                                        <i class='bx bx-check-shield' style="font-size: 22px;"></i>
                                        Privacy Policy</a>
                                </li>
                                <li>
                                    <a [routerLinkActive]="'active'" [routerLink]="['/cookie-policy']"
                                        class=" nav-link scrollto" data-bs-dismiss="modal">
                                        <i class='bx bx-cookie' style="font-size: 22px;"></i>
                                        Cookie Policy</a>

                                </li>
                                <li>
                                    <a [routerLinkActive]="'active'" [routerLink]="['/contact-us']"
                                        class=" nav-link scrollto" data-bs-dismiss="modal">
                                        <i class='bx bx-support' style="font-size: 22px;"></i>
                                        Contact Us</a>
                                </li>
                            </ul>
                        </ul>
                    </div>

                </div>


            </div>
            <div class="modal-footer">
                <div class="login-mobile" *ngIf="!isLoggedIn">
                    <ul>
                        <li class="" *ngIf="!isLoggedIn"><a (click)="signInSignUp()" class="nav-link scrollto"
                                data-bs-dismiss="modal">
                                <button class="btn find-patner-btn"> <span class="mr-3"></span> LOGIN/REGISTER </button>
                            </a>
                        </li>
                        <!-- <li class="" *ngIf="!isLoggedIn"><a class="nav-link scrollto disabled-list  "
                                data-bs-dismiss="modal">
                                <button class="btn Proplayer-btn">
                                    <span class="mr-3"></span> REGISTER</button> </a></li> -->

                        <!-- <li class="" *ngIf="!isLoggedIn"><a (click)="signInSignUp()" class="nav-link scrollto "
                                data-bs-dismiss="modal">
                                <button class="btn Proplayer-btn"> <span class="mr-3"></span> REGISTER</button> </a>
                        </li> -->
                    </ul>
                </div>
                <div class="login" *ngIf="isLoggedIn">
                    <!-- <li *ngIf="!isAcademy" class="refer-list-ui"><a  (click)="shareWhatsApp()" [routerLinkActive]="'active' "
                        class="nav-link scrollto"><span>Refer & Earn</span><i class='bx bx-share-alt'></i>  </a>
                     </li> -->

                    <!-- <a  href="{{shareurl}}" target="_blank"> <button *ngIf="!isAcademy"  class="refer-list-ui">
                        <span>Refer & Earn</span><i class='bx bx-share-alt'></i>
                    </button>
                </a> -->
                    <button data-bs-dismiss="modal" (click)="signOut()" *ngIf="isLoggedIn">
                        <span><i class='bx bx-log-out-circle'></i> Logout</span>
                    </button>
                </div>
            </div>

        </div>
    </div>
</div>


<!-- <div style="margin: 20px;">
    <button (click)="loadMoreNotification()" [disabled]="loading">Load More</button>

    <p-virtualScroller rows="5"
      [value]="items"
      scrollHeight="450px"
      [itemSize]="100"
      [lazy]="true"
      (onLazyLoad)="onLazyLoadNotification($event)" >
      <ng-template pTemplate="item" let-item  let-options="options" >
        <div> {{item.created_at | date: 'dd MMM, yyyy'}}  {{i + 1}} {{ item.description }}</div>
      </ng-template>
      <ng-template let-item pTemplate="loading" *ngIf="loading">
        <p-skeleton height="90px" [style]="{ 'margin-top': '10px' }"></p-skeleton>
      </ng-template>
    </p-virtualScroller>
  </div>
   -->

<p-dialog [(visible)]="notificationListpoup" id="notificationPopup-modal">
    <ng-template pTemplate="header">
        <h4>Notification ({{totalCount < 0 ? 0:totalCount}} new)</h4>
    </ng-template>
    <p-table [value]="finalnotificationList" [tableStyle]="{'min-width': '100%'}"
        (onLazyLoad)="onLazyLoadNotification()">
        <ng-template pTemplate="body" let-item>
            <tr>
                <td>
                    <div (click)="popNotification(item.id)" class="notification-list-div"
                        [ngClass]="{ 'active': i === selectedItemIndex }">
                        <!-- <div class="icon">                            
                            <img *ngIf="item.type=='Tournament'" src="assets/img/notification-icon/tournament.svg"
                                alt="">
                            <img *ngIf="item.type=='MyTournament'" src="assets/img/notification-icon/tournament.svg"
                                alt="">
                            <img *ngIf="item.type=='FAP'" src="assets/img/notification-icon/findapartner.svg" alt="">
                            <img *ngIf="item.type=='Contest'" src="assets/img/notification-icon/contest.svg" alt="">
                            <img *ngIf="item.type=='MyContest'" src="assets/img/notification-icon/contest.svg" alt="">
                            <img *ngIf="item.type=='Kyc'" src="assets/img/notification-icon/bank.svg" alt="">
                        </div> -->
                        <div class="ntf-body">
                            <!-- <h6>Ultim8 Tennis League Results Are In! </h6> -->
                            <!-- <h6>{{ item.message }}</h6> -->
                            <a *ngIf="item.type=='Tournament'" routerLink="/tournaments" class="notificationAnchor"
                                (click)="markNotificationRead(item.id,true)">
                                <h6 [innerHtml]="item.message"></h6>
                                <span class="date">{{item.created_at |date:'dd/MM/yyyy HH:mm a'}}</span>
                                <span *ngIf="!item.read" class="notseen"></span>
                            </a>
                            <a *ngIf="item.type=='MyTournament'" routerLink="/profile-tournament"
                                class="notificationAnchor" (click)="markNotificationRead(item.id,true)">
                                <h6 [innerHtml]="item.message"></h6>
                                <span class="date">{{item.created_at |date:'dd/MM/yyyy HH:mm a'}}</span>
                                <span *ngIf="!item.read" class="notseen"></span>
                            </a>
                            <a *ngIf="item.type=='FAP'" routerLink="/profile-request" class="notificationAnchor"
                                (click)="markNotificationRead(item.id,true)">
                                <h6 [innerHtml]="item.message"></h6>
                                <span class="date">{{item.created_at |date:'dd/MM/yyyy HH:mm a'}}</span>
                                <span *ngIf="!item.read" class="notseen"></span>
                            </a>
                            <a *ngIf="item.type=='Contest'" routerLink="/contest" class="notificationAnchor"
                                (click)="markNotificationRead(item.id,true)">
                                <h6 [innerHtml]="item.message"></h6>
                                <span class="date">{{item.created_at |date:'dd/MM/yyyy HH:mm a'}}</span>
                                <span *ngIf="!item.read" class="notseen"></span>
                            </a>
                            <a *ngIf="item.type=='MyContest'" routerLink="/my-contest" class="notificationAnchor"
                                (click)="markNotificationRead(item.id,true)">
                                <h6 [innerHtml]="item.message"></h6>
                                <span class="date">{{item.created_at |date:'dd/MM/yyyy HH:mm a'}}</span>
                                <span *ngIf="!item.read" class="notseen"></span>
                            </a>
                            <a *ngIf="item.type=='Kyc'" routerLink="/profile-info" class="notificationAnchor"
                                (click)="markNotificationRead(item.id,true)">
                                <h6 [innerHtml]="item.message"></h6>
                                <span class="date">{{item.created_at |date:'dd/MM/yyyy HH:mm a'}}</span>
                                <span *ngIf="!item.read" class="notseen"></span>
                            </a>
                            <a *ngIf="item.type=='Wallet'" routerLink="/my-wallet" class="notificationAnchor"
                                (click)="markNotificationRead(item.id,true)">
                                <h6 [innerHtml]="item.message"></h6>
                                <span class="date">{{item.created_at |date:'dd/MM/yyyy HH:mm a'}}</span>
                                <span *ngIf="!item.read" class="notseen"></span>
                            </a>

                            <!-- <p>{{ item.description }}</p> -->
                            <!-- <span class="date">{{item.created_at |date:'dd/MM/yyyy HH:mm a'}}</span>
                            <span *ngIf="!item.read" class="notseen"></span> -->
                        </div>
                    </div>

                </td>

            </tr>
        </ng-template>
    </p-table>
    <ng-template pTemplate="footer">
        <div class="notification-view-all">
            <button (click)="loadMoreNotification()">See More
                Notification</button>
        </div>
    </ng-template>
</p-dialog>

<p-dialog id="downloadApp" [closable]="true" [(visible)]="downloadAffiliateModal" [modal]="true"
    [style]="{width: '600px'}" [breakpoints]="{'960px': '60vw', '640px': 'calc(100% - 60px)'}" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false">
    <div class="mainBody">
        <div class="toptitle">
            <h2>play. compete. connect</h2>
            <p>Discover exclusive features, register for TPL tournaments, book <br>nearby courts, and find partners
                anytime,
                anywhere on TPL App!</p>
        </div>
        <div class="downloadBtn">
           <button (click)="openApp(APP_LINKS.partner.android)">
                <img src="../../../assets/images/header/GooglePlay.svg" alt="">
            </button>
            <button (click)="openApp(APP_LINKS.partner.ios)">
                <img src="../../../assets/images/header/AppStore.svg" alt="">
            </button>
        </div>
        <!-- <div class="line">
            <hr>
        </div> -->
        <!-- <div class="qrCode-div">
            <p>You can also scan this QR Code to download the app</p>
            <div class="qrcodeimage">
                <img src="../../../assets/images/header/qrcode.png" alt="">
            </div>
        </div> -->
        <!-- <form class="downloadMobileNumber" [formGroup]="mobileLoginForm">
            <div class="mobile0numberField">
                <div class="countryCode">
                    <p-dropdown inputId="phoneCode" formControlName="phoneCode" appendTo="body"
                        [options]="countryCodeList" optionLabel="phone_code" (onChange)="setCountryCode($event)"
                        [filter]="true"
                        [ngClass]="{ 'ng-dirty ng-invalid': submitted && this.mobileLoginForm.get('phoneCode').errors }">
                        <ng-template pTemplate="selectedItem" let-selectedOption>
                            <div class="flex justify-content-center align-items-center gap-2">
                                <img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                                    [class]="'flag flag-' + selectedOption.code.toLowerCase()" style="width: 18px" />
                                <div>{{ selectedOption.phone_code }}</div>
                            </div>
                        </ng-template>
                        <ng-template let-country pTemplate="item">
                            <div class="flex align-items-center gap-2">
                                <img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                                    [class]="'flag flag-' + country.code.toLowerCase()"
                                    style="width: 18px" />&nbsp;&nbsp;
                                <span>{{ country?.phone_code }}</span>
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>
                <p-inputNumber [useGrouping]="false" id="inputtext-left" formControlName="mobileNumber" [maxlength]="10"
                    placeholder="Enter mobile number" required>
                </p-inputNumber>
            </div>

            <div class="whatsappBtn">
                <button>
                    <span>
                        <img src="../../../assets/images/header/whatsapp.svg" alt="">
                    </span>
                    <div class="title">
                        Get the link on whatsapp
                    </div>
                </button>
            </div>
        </form> -->
    </div>
</p-dialog>

<p-dialog id="downloadApp" [closable]="true" [(visible)]="downloadAppModal" [modal]="true" [style]="{width: '600px'}"
    [breakpoints]="{'960px': '60vw', '640px': 'calc(100% - 60px)'}" [baseZIndex]="10000" [draggable]="false"
    [resizable]="false">
    <div class="mainBody">
        <div class="toptitle">
            <h2>play. compete. connect</h2>
            <p>Discover exclusive features, register for TPL tournaments, book <br>nearby courts, and find partners
                anytime,
                anywhere on TPL App!</p>
        </div>
        <div class="downloadBtn">
            <button (click)="openApp(APP_LINKS.player.android)">
                <img src="../../../assets/images/header/GooglePlay.svg" alt="">
            </button>
            <button (click)="openApp(APP_LINKS.player.ios)">
                <img src="../../../assets/images/header/AppStore.svg" alt="">
            </button>
        </div>
        <!-- <div class="line">
            <hr>
        </div> -->
        <!-- <div class="qrCode-div">
            <p>You can also scan this QR Code to download the app</p>
            <div class="qrcodeimage">
                <img src="../../../assets/images/header/qrcode.png" alt="">
            </div>
        </div>
        <form class="downloadMobileNumber" [formGroup]="mobileLoginForm">
            <div class="mobile0numberField">
                <div class="countryCode">
                    <p-dropdown inputId="phoneCode" formControlName="phoneCode" appendTo="body"
                        [options]="countryCodeList" optionLabel="phone_code" (onChange)="setCountryCode($event)"
                        [filter]="true"
                        [ngClass]="{ 'ng-dirty ng-invalid': submitted && this.mobileLoginForm.get('phoneCode').errors }">
                        <ng-template pTemplate="selectedItem" let-selectedOption>
                            <div class="flex justify-content-center align-items-center gap-2">
                                <img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                                    [class]="'flag flag-' + selectedOption.code.toLowerCase()" style="width: 18px" />
                                <div>{{ selectedOption.phone_code }}</div>
                            </div>
                        </ng-template>
                        <ng-template let-country pTemplate="item">
                            <div class="flex align-items-center gap-2">
                                <img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                                    [class]="'flag flag-' + country.code.toLowerCase()"
                                    style="width: 18px" />&nbsp;&nbsp;
                                <span>{{ country?.phone_code }}</span>
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>
                <p-inputNumber [useGrouping]="false" id="inputtext-left" formControlName="mobileNumber" [maxlength]="10"
                    placeholder="Enter mobile number" required>
                </p-inputNumber>
            </div>

            <div class="whatsappBtn">
                <button>
                    <span>
                        <img src="../../../assets/images/header/whatsapp.svg" alt="">
                    </span>
                    <div class="title">
                        Get the link on whatsapp
                    </div>
                </button>
            </div>
        </form> -->
    </div>
</p-dialog>

<p-dialog [closable]="true" [(visible)]="downloadModal" [modal]="true" [style]="{width: '416px'}"
    id="downloadModalPopup" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false" [closable]="false" [position]="position">
    <div class="downloadbody">
        <div class="topleftbg">
            <img src="../../../../assets/images/download/topleft.png" alt="">
        </div>
        <div class="bottomrightbg">
            <img src="../../../../assets/images/download/bottomright.png" alt="">
        </div>
        <div class="bottomleftbg">
            <img src="../../../../assets/images/download/bottomleft.png" alt="">
        </div>
        <div class="download-header">
            <button (click)="downloadModal = false" class="closeBtn">
                <img src="assets/images/download/close.svg" alt="">
            </button>
        </div>
        <div class="bannerImage">
            <img src="../../../../assets/images/download/leander.png" alt="">
        </div>
        <div class="modalTitleImage">
            <img src="../../../../assets/images/download/modalTile.svg" alt="">
        </div>

        <div class="downloadList">
            <ul>
                <li>
                    <a href="https://play.google.com/store/apps/details?id=com.wiantech.tplsport&pcampaignid=web_share">
                        <img src="../../../../assets/images/download/btn1.png" alt="">
                    </a>
                </li>
                <li>
                    <a href="https://apps.apple.com/in/app/tpl-tennis-premier-league/id6461867254">
                        <img src="../../../../assets/images/download/btn2.png" alt="">
                    </a>
                </li>
            </ul>
        </div>

        <div class="orTitle">
            <div class="line"></div>
            <p>OR</p>
            <div class="line"></div>
        </div>
        <div class="scanner">
            <img src="../../../../assets/images/download/qrcode.png" alt="">
        </div>
        <div class="notesdiv">
            <p>Click the buttons above to download the <span>App!</span></p>
        </div>
    </div>
</p-dialog>

<p-dialog [closable]="true" [(visible)]="mobileMenues" [modal]="true" [style]="{width: '416px'}" id="profile-popup"
    [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [baseZIndex]="10000" [draggable]="false"
    [resizable]="false" [closable]="false" [position]="position">
    <ng-template pTemplate="content">
        <div class="profile-menues">
            <div class="profile-header">
                <div class="left-user-details">
                    <div class="profileImage">
                        <img [src]="(loggedInProfilePic.length !== 0) ? loggedInProfilePic : '../../../../assets/images/academy_dummy.jpg'"
                            alt="">
                    </div>
                    <div class="username">
                        <h4>{{loggedInUsername}}</h4>
                    </div>
                    <div class="subscribe">
                        <h6 routerLink="profile-info" (click)="mobileMenues = false">VIEW PROFILE</h6>
                    </div>
                </div>
                <div class="right-user-details">
                    <div class="subscribe">
                        <button>
                            <img src="../../../assets/images/header/subscribe.svg" alt="">
                        </button>
                    </div>
                    <h6>TPL RANK</h6>
                    <h2>#{{playerRank}}</h2>
                </div>
                <div class="closeBtn">
                    <button (click)="mobileMenues = false">
                        <img src="../../../assets/images/header/cancel-01.svg" alt="">
                    </button>
                </div>
            </div>
            <div class="profile-body">
                <div class="subscribeDiv" (click)="onDownloadClick('bottom');">
                    <div class="leftDiv">
                        <div class="logo">
                            <img src="../../../assets/images/header/subLogo.png" alt="">
                        </div>
                        <div class="title">
                            <h6>Subscribe now!</h6>
                            <p>for exclusive benefits</p>
                        </div>
                    </div>
                    <div class="rightDiv">
                        <div class="icon">
                            <img src="../../../assets/images/header/rightIcon.svg" alt="">
                        </div>
                    </div>
                </div>
                <div class="mobileSwichAccount">
                    <div class="swichAccount" (click)="onDownloadClick('bottom'); mobileMenues = false">
                        <div class="accountSwith">
                            <div class="icon">
                                <img src="../../../assets/images/header/user-switch.svg" alt="">
                            </div>
                            <div class="title">
                                switch account
                            </div>
                        </div>
                        <div class="users">
                            <div class="user-main0div">
                                <p-avatarGroup styleClass="p-mb-0">
                                    <p-avatar image="assets/demo/images/avatar/amyelsner.png" size="large"
                                        shape="circle"></p-avatar>
                                    <p-avatar image="assets/demo/images/avatar/asiyajavayant.png" size="large"
                                        shape="circle"></p-avatar>

                                    <p-avatar label="+2" shape="circle" size="large"
                                        [style]="{'font-family':'Gilroy-SemiBold','font-size':'20px','background-color':'#E3F2E5', 'color': '#1C9A2D', 'border-color': '#1C9A2D'}"></p-avatar>
                                </p-avatarGroup>
                            </div>
                            <div class="icon">
                                <img src="../../../assets/images/header/m-right.svg" alt="">
                            </div>

                        </div>
                    </div>
                </div>
                <div class="walletAcmainDiv">
                    <div class="walletAccount">
                        <div class="leftdiv">
                            <div class="icon">
                                <img src="../../../assets/images/header/wallet-02.svg" alt="">
                            </div>
                            <div class="title">
                                <h6>Current Balance</h6>
                                <h4>₹{{totalAvailableCash | number:'1.2-2'}}</h4>
                            </div>
                        </div>
                        <div class="rightdiv">
                            <button (click)="openWallet();  mobileMenues = false">
                                Add Cash
                            </button>
                        </div>
                    </div>
                </div>
                <!-- <div class="panel-details">
                    <ul>
                        <li>
                            <div class="icons-div">
                                <div class="icon">
                                    <img src="../../../assets/images/header/location.svg" alt="">
                                </div>
                                <div class="title">
                                    <h4>Mumbai</h4>
                                </div>
                            </div>
                        </li>
                        <li>
                            <a routerLink="my-wallet">
                                <div class="icons-div">
                                    <div class="icon">
                                        <img src="../../../assets/images/header/wallet.svg" alt="">
                                    </div>
                                    <div class="title">
                                        <h4>₹5000</h4>
                                    </div>
                                </div>
                            </a>

                        </li>
                        <li>

                            <div class="icons-div">
                                <div class="icon">
                                    <img src="../../../assets/images/header/notification.svg" alt="">
                                </div>
                                <div class="title">
                                    <h4>03</h4>
                                </div>
                            </div>

                        </li>
                    </ul>
                </div> -->

                <div class="navMenue_main">
                    <div class="notificationList">
                        <ul>
                            <li style="padding-top: 0px !important;">
                                <a routerLink="refer-earn" (click)="mobileMenues = false">
                                    <div class="menuesList">
                                        <div class="icon">
                                            <img src="../../../assets/images/header/user-star.svg" alt="">
                                        </div>
                                        <div class="title">
                                            <span>
                                                Refer and Earn
                                            </span>
                                            <h6>Get <span style="color: #1C9A2D;" class="hightlightspan">₹100</span> for
                                                every referral</h6>
                                        </div>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <p-accordion>
                                    <p-accordionTab>
                                        <ng-template pTemplate="header">
                                            <span class="flex align-items-center gap-2 w-full">
                                                <div class="icon">
                                                    <img src="../../../assets/images/header/aboutLeagueicon.png" alt="">
                                                </div>
                                                <span class="mainMenueTitle">
                                                    Tennis Premier League
                                                </span>

                                            </span>
                                        </ng-template>

                                        <ul class="subMenueslist">
                                            <li>
                                                <a routerLink="about-the-league" (click)="mobileMenues = false">
                                                    <span class="flex align-items-center gap-2 w-full">

                                                        <span class="mainMenueTitle">
                                                            About TPL
                                                        </span>

                                                    </span>
                                                </a>

                                            </li>
                                            <li>
                                                <a  class="cursor-pointer" (click)="onDownloadClick('bottom'); mobileMenues = false">
                                                    <span class="flex align-items-center gap-2 w-full">

                                                        <span class="mainMenueTitle">
                                                            Match Score
                                                        </span>

                                                    </span>
                                                </a>

                                            </li>
                                            <li>
                                                <a  (click)="onDownloadClick('bottom'); mobileMenues = false">
                                                    <span class="flex align-items-center gap-2 w-full">

                                                        <span class="mainMenueTitle">
                                                            TPL Team Standings
                                                        </span>

                                                    </span>
                                                </a>

                                            </li>
                                            <li>
                                                <a routerLink="teams" (click)="mobileMenues = false">
                                                    <span class="flex align-items-center gap-2 w-full">

                                                        <span class="mainMenueTitle">
                                                            Teams
                                                        </span>

                                                    </span>
                                                </a>

                                            </li>
                                            <li>
                                                <a routerLink="sponsors" (click)="mobileMenues = false">
                                                    <span class="flex align-items-center gap-2 w-full">

                                                        <span class="mainMenueTitle">
                                                            Sponsors
                                                        </span>

                                                    </span>
                                                </a>

                                            </li>
                                            <li>
                                                <a routerLink="media" (click)="mobileMenues = false">
                                                    <span class="flex align-items-center gap-2 w-full">

                                                        <span class="mainMenueTitle">
                                                            Media
                                                        </span>

                                                    </span>
                                                </a>

                                            </li>
                                            <li>
                                                <a (click)="onDownloadClick('bottom'); mobileMenues = false">
                                                    <span class="flex align-items-center gap-2 w-full">

                                                        <span class="mainMenueTitle">
                                                            Highlights
                                                        </span>

                                                    </span>
                                                </a>

                                            </li>
                                            <li>
                                                <a (click)="onDownloadClick('bottom'); mobileMenues = false">
                                                    <span class="flex align-items-center gap-2 w-full">

                                                        <span class="mainMenueTitle">
                                                            Player Stats
                                                        </span>

                                                    </span>
                                                </a>

                                            </li>
                                        </ul>

                                    </p-accordionTab>
                                </p-accordion>
                            </li>
                            <li>
                                <p-accordion>
                                    <p-accordionTab>
                                        <ng-template pTemplate="header">
                                            <span class="flex align-items-center gap-2 w-full">
                                                <div class="icon">
                                                    <img src="../../../assets/images/header/m-IconTorunament.svg"
                                                        alt="">
                                                </div>
                                                <span class="mainMenueTitle">
                                                    Tournaments
                                                </span>

                                            </span>
                                        </ng-template>

                                        <ul class="subMenueslist">
                                            <li>
                                                <a routerLink="/tournaments" (click)="mobileMenues = false">
                                                    <span class="flex align-items-center gap-2 w-full">

                                                        <span class="mainMenueTitle">
                                                            All Tournaments
                                                        </span>

                                                    </span>
                                                </a>

                                            </li>
                                            <li>
                                                <a (click)="onDownloadClick('bottom'); mobileMenues = false">
                                                    <span class="flex align-items-center gap-2 w-full">

                                                        <span class="mainMenueTitle">
                                                            My Tournaments
                                                        </span>

                                                    </span>
                                                </a>

                                            </li>

                                        </ul>

                                    </p-accordionTab>
                                </p-accordion>
                            </li>
                            <li>
                                <p-accordion>
                                    <p-accordionTab>
                                        <ng-template pTemplate="header">
                                            <span class="flex align-items-center gap-2 w-full">
                                                <div class="icon">
                                                    <img src="../../../assets/images/header/m-IconBookcourt.svg" alt="">
                                                </div>
                                                <span class="mainMenueTitle">
                                                    Book A Court
                                                </span>

                                            </span>
                                        </ng-template>

                                        <ul class="subMenueslist">
                                            <li>
                                                <a (click)="onDownloadClick('bottom'); mobileMenues = false">
                                                    <span class="flex align-items-center gap-2 w-full">

                                                        <span class="mainMenueTitle">
                                                            All Courts
                                                        </span>

                                                    </span>
                                                </a>

                                            </li>
                                            <li>
                                                <a (click)="onDownloadClick('bottom'); mobileMenues = false">
                                                    <span class="flex align-items-center gap-2 w-full">

                                                        <span class="mainMenueTitle">
                                                            My Bookings
                                                        </span>

                                                    </span>
                                                </a>

                                            </li>

                                        </ul>

                                    </p-accordionTab>
                                </p-accordion>
                            </li>
                            <li>
                                <p-accordion>
                                    <p-accordionTab>
                                        <ng-template pTemplate="header">
                                            <span class="flex align-items-center gap-2 w-full">
                                                <div class="icon">
                                                    <img src="../../../assets/images/header/m-IconAcadmy.svg" alt="">
                                                </div>
                                                <span class="mainMenueTitle">
                                                    Academies
                                                </span>

                                            </span>
                                        </ng-template>

                                        <ul class="subMenueslist">
                                            <li>
                                                <a routerLink="/academies" (click)="mobileMenues = false">
                                                    <span class="flex align-items-center gap-2 w-full">

                                                        <span class="mainMenueTitle">
                                                            All Academies
                                                        </span>

                                                    </span>
                                                </a>

                                            </li>
                                            <li>
                                                <a (click)="onDownloadClick('bottom'); mobileMenues = false">
                                                    <span class="flex align-items-center gap-2 w-full">

                                                        <span class="mainMenueTitle">
                                                            My Academies
                                                        </span>

                                                    </span>
                                                </a>
                                            </li>
                                        </ul>

                                    </p-accordionTab>
                                </p-accordion>
                            </li>
                            <li>
                                <p-accordion>
                                    <p-accordionTab>
                                        <ng-template pTemplate="header">
                                            <span class="flex align-items-center gap-2 w-full">
                                                <div class="icon">
                                                    <img src="../../../assets/images/header/m-Iconfindp.svg" alt="">
                                                </div>
                                                <span class="mainMenueTitle">
                                                    Find a partner
                                                </span>

                                            </span>
                                        </ng-template>

                                        <ul class="subMenueslist">
                                            <li>
                                                <a routerLink="find-partner" (click)="mobileMenues = false">
                                                    <span class="flex align-items-center gap-2 w-full">

                                                        <span class="mainMenueTitle">
                                                            Search
                                                        </span>

                                                    </span>
                                                </a>

                                            </li>
                                            <li>
                                                <a (click)="onDownloadClick('bottom'); mobileMenues = false">
                                                    <span class="flex align-items-center gap-2 w-full">

                                                        <span class="mainMenueTitle">
                                                            List Yourself
                                                        </span>

                                                    </span>
                                                </a>

                                            </li>

                                            <li>
                                                <a (click)="onDownloadClick('bottom'); mobileMenues = false">
                                                    <span class="flex align-items-center gap-2 w-full">

                                                        <span class="mainMenueTitle">
                                                            My Schedule
                                                        </span>

                                                    </span>
                                                </a>

                                            </li>


                                        </ul>

                                    </p-accordionTab>
                                </p-accordion>
                            </li>
                            <!-- <li>
                                <p-accordion>
                                    <p-accordionTab>
                                        <ng-template pTemplate="header">
                                            <span class="flex align-items-center gap-2 w-full">
                                                <div class="icon">
                                                    <img src="../../../assets/images/header/m-IconContest.svg" alt="">
                                                </div>
                                                <span class="mainMenueTitle">
                                                    Contests
                                                </span>

                                            </span>
                                        </ng-template>

                                        <ul class="subMenueslist">
                                            <li>
                                                <a routerLink="/contest " (click)="mobileMenues = false">
                                                    <span class="flex align-items-center gap-2 w-full">

                                                        <span class="mainMenueTitle">
                                                            All Contests
                                                        </span>

                                                    </span>
                                                </a>

                                            </li>
                                            <li>
                                                <a routerLink="/contest-history " (click)="mobileMenues = false">
                                                    <span class="flex align-items-center gap-2 w-full">

                                                        <span class="mainMenueTitle">
                                                            My Contests
                                                        </span>

                                                    </span>
                                                </a>

                                            </li>
                                            <li>
                                                <a routerLink="contest-leaderboard" (click)="mobileMenues = false">
                                                    <span class="flex align-items-center gap-2 w-full">

                                                        <span class="mainMenueTitle">
                                                            Leaderboard
                                                        </span>

                                                    </span>
                                                </a>

                                            </li>

                                        </ul>

                                    </p-accordionTab>
                                </p-accordion>
                            </li> -->
                            <li>
                                <!-- <a routerLink="leaderboard" (click)="mobileMenues = false"> -->
                                <a (click)="onDownloadClick('bottom'); mobileMenues = false">
                                    <div class="menuesList">
                                        <div class="icon">
                                            <img src="../../../assets/images/header/m-Iconrank.svg" alt="">
                                        </div>
                                        <div class="title">

                                            <span>Rankings</span>
                                        </div>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a (click)="onDownloadClick('bottom'); mobileMenues = false">
                                    <div class="menuesList">
                                        <div class="icon">
                                            <img src="../../../assets/images/header/m-IconEstore.svg" alt="">
                                        </div>
                                        <div class="title">

                                            <span>E-Store</span>
                                        </div>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a routerLink="race-to-gold" (click)="mobileMenues = false">
                                    <div class="menuesList">
                                        <div class="icon">
                                            <img src="../../../assets/images/header/m-Iconrace.svg" alt="">
                                        </div>
                                        <div class="title">

                                            <span>Race to Gold</span>
                                        </div>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a (click)="onDownloadClick('bottom'); mobileMenues = false">
                                    <div class="menuesList">
                                        <div class="icon">
                                            <img src="../../../assets/images/header/m-IconLive.svg" alt="">
                                        </div>
                                        <div class="title">

                                            <span>Live Score</span>
                                        </div>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a (click)="onDownloadClick('bottom'); mobileMenues = false">
                                    <div class="menuesList">
                                        <div class="icon">
                                            <img src="../../../assets/images/header/m-Iconreddem.svg" alt="">
                                        </div>
                                        <div class="title">

                                            <span>Redeem Rewards1</span>
                                        </div>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <p-accordion>
                                    <p-accordionTab>
                                        <ng-template pTemplate="header">
                                            <span class="flex align-items-center gap-2 w-full">
                                                <div class="icon">
                                                    <img src="../../../assets/images/header/m-IconInfo.svg" alt="">
                                                </div>
                                                <span class="mainMenueTitle">
                                                    Information
                                                </span>

                                            </span>
                                        </ng-template>

                                        <ul class="subMenueslist">
                                            <li>
                                                <a routerLink="termsandcondition" (click)="mobileMenues = false">
                                                    <span class="flex align-items-center gap-2 w-full">

                                                        <span class="mainMenueTitle">
                                                            Terms and Conditions
                                                        </span>

                                                    </span>
                                                </a>

                                            </li>
                                            <li>
                                                <a routerLink="refund-policy" (click)="mobileMenues = false">
                                                    <span class="flex align-items-center gap-2 w-full">

                                                        <span class="mainMenueTitle">
                                                            Refund Policy
                                                        </span>

                                                    </span>
                                                </a>

                                            </li>
                                            <li>
                                                <a routerLink="data-protection-policy" (click)="mobileMenues = false">
                                                    <span class="flex align-items-center gap-2 w-full">

                                                        <span class="mainMenueTitle">
                                                            Data Protection Policy
                                                        </span>

                                                    </span>
                                                </a>

                                            </li>
                                            <li>
                                                <a routerLink="privacy-policy" (click)="mobileMenues = false">
                                                    <span class="flex align-items-center gap-2 w-full">

                                                        <span class="mainMenueTitle">
                                                            Privacy Policy
                                                        </span>

                                                    </span>
                                                </a>

                                            </li>
                                            <li>
                                                <a routerLink="cookie-policy" (click)="mobileMenues = false">
                                                    <span class="flex align-items-center gap-2 w-full">

                                                        <span class="mainMenueTitle">
                                                            Cookie Policy
                                                        </span>

                                                    </span>
                                                </a>

                                            </li>
                                            <li>
                                                <a routerLink="contact-us" (click)="mobileMenues = false">
                                                    <span class="flex align-items-center gap-2 w-full">

                                                        <span class="mainMenueTitle">
                                                            Help & Support
                                                        </span>

                                                    </span>
                                                </a>

                                            </li>

                                        </ul>

                                    </p-accordionTab>
                                </p-accordion>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="logoutbtn">
                    <button (click)="signOut()">
                        <div class="icon">
                            <img src="../../assets/images/login/logout.svg" alt="">
                        </div>
                        <div class="text">
                            Log out
                        </div>
                    </button>
                </div>
            </div>

        </div>
    </ng-template>
</p-dialog>